// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  :root {
    --background: 90 30% 97%;
    --foreground: 0 0% 20%;
    --card: 0 0% 100%;
    --card-foreground: 0 0% 20%;
    --popover: 0 0% 100%;
    --popover-foreground: 0 0% 20%;
    --primary: 100 78% 24%;
    --primary-foreground: 90 30% 97%;
    --secondary: 92 37% 86%;
    --secondary-foreground: 100 78% 20%;
    --muted: 90 25% 94%;
    --muted-foreground: 0 0% 40%;
    --accent: 98 47% 40%;
    --accent-foreground: 0 0% 100%;
    --destructive: 0 100% 41%;
    --destructive-foreground: 0 0% 98%;
    --border: 92 35% 82%;
    --input: 92 35% 82%;
    --ring: 100 78% 24%;
    --radius: 0.75rem;
  }
  .dark {
    --background: 20 14% 8%;
    --foreground: 40 33% 95%;
    --card: 20 14% 12%;
    --card-foreground: 40 33% 95%;
    --popover: 20 14% 12%;
    --popover-foreground: 40 33% 95%;
    --primary: 205 60% 55%;
    --primary-foreground: 20 14% 8%;
    --secondary: 20 10% 18%;
    --secondary-foreground: 40 33% 95%;
    --muted: 20 10% 18%;
    --muted-foreground: 40 10% 65%;
    --accent: 18 65% 60%;
    --accent-foreground: 20 14% 8%;
    --destructive: 0 63% 45%;
    --destructive-foreground: 40 33% 95%;
    --border: 20 10% 22%;
    --input: 20 10% 22%;
    --ring: 205 60% 55%;
  }
  * {
  border-color: hsl(var(--border));
}
  body {
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
}
  [data-debug-wrapper="true"] { display: contents !important; }
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.\\!fixed {
  position: fixed !important;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-10 {
  bottom: -2.5rem;
}
.-bottom-12 {
  bottom: -3rem;
}
.-left-12 {
  left: -3rem;
}
.-left-\\[5px\\] {
  left: -5px;
}
.-left-\\[9999px\\] {
  left: -9999px;
}
.-right-12 {
  right: -3rem;
}
.-right-16 {
  right: -4rem;
}
.-right-2 {
  right: -0.5rem;
}
.-top-12 {
  top: -3rem;
}
.-top-16 {
  top: -4rem;
}
.-top-2 {
  top: -0.5rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-1\\.5 {
  bottom: 0.375rem;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\.5 {
  left: 0.375rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-2\\.5 {
  left: 0.625rem;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-8 {
  left: 2rem;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-1\\.5 {
  right: 0.375rem;
}
.right-14 {
  right: 3.5rem;
}
.right-2 {
  right: 0.5rem;
}
.right-2\\.5 {
  right: 0.625rem;
}
.right-28 {
  right: 7rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-5 {
  right: 1.25rem;
}
.right-6 {
  right: 1.5rem;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\.5 {
  top: 0.375rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-20 {
  top: 5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-\\[137px\\] {
  top: 137px;
}
.top-\\[1px\\] {
  top: 1px;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.top-\\[60\\%\\] {
  top: 60%;
}
.top-\\[76px\\] {
  top: 76px;
}
.top-\\[var\\(--header-h\\)\\] {
  top: var(--header-h);
}
.top-full {
  top: 100%;
}
.isolate {
  isolation: isolate;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[55\\] {
  z-index: 55;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[70\\] {
  z-index: 70;
}
.z-\\[80\\] {
  z-index: 80;
}
.z-\\[90\\] {
  z-index: 90;
}
.z-\\[95\\] {
  z-index: 95;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.row-span-2 {
  grid-row: span 2 / span 2;
}
.m-0 {
  margin: 0px;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-2 {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.-mx-6 {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.-my-1 {
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.-mb-1 {
  margin-bottom: -0.25rem;
}
.-mb-2 {
  margin-bottom: -0.5rem;
}
.-mb-3 {
  margin-bottom: -0.75rem;
}
.-mb-6 {
  margin-bottom: -1.5rem;
}
.-mb-px {
  margin-bottom: -1px;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-ml-2 {
  margin-left: -0.5rem;
}
.-ml-4 {
  margin-left: -1rem;
}
.-ml-8 {
  margin-left: -2rem;
}
.-mt-0\\.5 {
  margin-top: -0.125rem;
}
.-mt-1 {
  margin-top: -0.25rem;
}
.-mt-10 {
  margin-top: -2.5rem;
}
.-mt-2 {
  margin-top: -0.5rem;
}
.-mt-3 {
  margin-top: -0.75rem;
}
.-mt-4 {
  margin-top: -1rem;
}
.-mt-6 {
  margin-top: -1.5rem;
}
.-mt-8 {
  margin-top: -2rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-0\\.5 {
  margin-right: 0.125rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-8 {
  margin-right: 2rem;
}
.mr-auto {
  margin-right: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-24 {
  margin-top: 6rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-3\\.5 {
  margin-top: 0.875rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-auto {
  margin-top: auto;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.line-clamp-4 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.line-clamp-5 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}
.line-clamp-6 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.\\!inline {
  display: inline !important;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none;
}
.aspect-\\[16\\/10\\] {
  aspect-ratio: 16/10;
}
.aspect-\\[16\\/9\\] {
  aspect-ratio: 16/9;
}
.aspect-\\[3\\/2\\] {
  aspect-ratio: 3/2;
}
.aspect-\\[4\\/3\\] {
  aspect-ratio: 4/3;
}
.aspect-\\[4\\/5\\] {
  aspect-ratio: 4/5;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.\\!h-6 {
  height: 1.5rem !important;
}
.h-0 {
  height: 0px;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-36 {
  height: 9rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-44 {
  height: 11rem;
}
.h-5 {
  height: 1.25rem;
}
.h-52 {
  height: 13rem;
}
.h-56 {
  height: 14rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-72 {
  height: 18rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[0\\.8em\\] {
  height: 0.8em;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[22px\\] {
  height: 22px;
}
.h-\\[320px\\] {
  height: 320px;
}
.h-\\[360px\\] {
  height: 360px;
}
.h-\\[38px\\] {
  height: 38px;
}
.h-\\[3px\\] {
  height: 3px;
}
.h-\\[420px\\] {
  height: 420px;
}
.h-\\[520px\\] {
  height: 520px;
}
.h-\\[62vh\\] {
  height: 62vh;
}
.h-\\[70vh\\] {
  height: 70vh;
}
.h-\\[72px\\] {
  height: 72px;
}
.h-\\[88vh\\] {
  height: 88vh;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\] {
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\] {
  height: var(--radix-select-trigger-height);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-24 {
  max-height: 6rem;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-56 {
  max-height: 14rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-72 {
  max-height: 18rem;
}
.max-h-80 {
  max-height: 20rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[--radix-context-menu-content-available-height\\] {
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\] {
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[40vh\\] {
  max-height: 40vh;
}
.max-h-\\[420px\\] {
  max-height: 420px;
}
.max-h-\\[45vh\\] {
  max-height: 45vh;
}
.max-h-\\[50vh\\] {
  max-height: 50vh;
}
.max-h-\\[520px\\] {
  max-height: 520px;
}
.max-h-\\[60vh\\] {
  max-height: 60vh;
}
.max-h-\\[640px\\] {
  max-height: 640px;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[72vh\\] {
  max-height: 72vh;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-\\[85vh\\] {
  max-height: 85vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[92vh\\] {
  max-height: 92vh;
}
.max-h-\\[calc\\(100vh-3rem\\)\\] {
  max-height: calc(100vh - 3rem);
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\] {
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-full {
  max-height: 100%;
}
.max-h-screen {
  max-height: 100vh;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-10 {
  min-height: 2.5rem;
}
.min-h-\\[160px\\] {
  min-height: 160px;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[2rem\\] {
  min-height: 2rem;
}
.min-h-\\[3\\.5rem\\] {
  min-height: 3.5rem;
}
.min-h-\\[320px\\] {
  min-height: 320px;
}
.min-h-\\[36px\\] {
  min-height: 36px;
}
.min-h-\\[380px\\] {
  min-height: 380px;
}
.min-h-\\[480px\\] {
  min-height: 480px;
}
.min-h-\\[50vh\\] {
  min-height: 50vh;
}
.min-h-\\[55vh\\] {
  min-height: 55vh;
}
.min-h-\\[560px\\] {
  min-height: 560px;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.min-h-\\[60vh\\] {
  min-height: 60vh;
}
.min-h-\\[calc\\(100vh-80px\\)\\] {
  min-height: calc(100vh - 80px);
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-6 {
  width: 1.5rem !important;
}
.w-0 {
  width: 0px;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[--radix-popover-trigger-width\\] {
  width: var(--radix-popover-trigger-width);
}
.w-\\[1\\.15em\\] {
  width: 1.15em;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[104px\\] {
  width: 104px;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[116px\\] {
  width: 116px;
}
.w-\\[136px\\] {
  width: 136px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[230px\\] {
  width: 230px;
}
.w-\\[260px\\] {
  width: 260px;
}
.w-\\[26rem\\] {
  width: 26rem;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[36\\%\\] {
  width: 36%;
}
.w-\\[360px\\] {
  width: 360px;
}
.w-\\[36px\\] {
  width: 36px;
}
.w-\\[46px\\] {
  width: 46px;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[7\\.5rem\\] {
  width: 7.5rem;
}
.w-\\[76px\\] {
  width: 76px;
}
.w-\\[78px\\] {
  width: 78px;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[90px\\] {
  width: 90px;
}
.w-\\[92px\\] {
  width: 92px;
}
.w-\\[96px\\] {
  width: 96px;
}
.w-\\[96vw\\] {
  width: 96vw;
}
.w-\\[min\\(100vw-1rem\\2c 48rem\\)\\] {
  width: min(100vw - 1rem,48rem);
}
.w-\\[min\\(360px\\2c 92\\%\\)\\] {
  width: min(360px,92%);
}
.w-\\[min\\(420px\\2c 90\\%\\)\\] {
  width: min(420px,90%);
}
.w-\\[var\\(--radix-popover-trigger-width\\)\\] {
  width: var(--radix-popover-trigger-width);
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.w-screen {
  width: 100vw;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-10 {
  min-width: 2.5rem;
}
.min-w-8 {
  min-width: 2rem;
}
.min-w-9 {
  min-width: 2.25rem;
}
.min-w-\\[1\\.25rem\\] {
  min-width: 1.25rem;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[12rem\\] {
  min-width: 12rem;
}
.min-w-\\[150px\\] {
  min-width: 150px;
}
.min-w-\\[160px\\] {
  min-width: 160px;
}
.min-w-\\[16rem\\] {
  min-width: 16rem;
}
.min-w-\\[190px\\] {
  min-width: 190px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[220px\\] {
  min-width: 220px;
}
.min-w-\\[22px\\] {
  min-width: 22px;
}
.min-w-\\[230px\\] {
  min-width: 230px;
}
.min-w-\\[240px\\] {
  min-width: 240px;
}
.min-w-\\[260px\\] {
  min-width: 260px;
}
.min-w-\\[300px\\] {
  min-width: 300px;
}
.min-w-\\[320px\\] {
  min-width: 320px;
}
.min-w-\\[640px\\] {
  min-width: 640px;
}
.min-w-\\[720px\\] {
  min-width: 720px;
}
.min-w-\\[7rem\\] {
  min-width: 7rem;
}
.min-w-\\[8rem\\] {
  min-width: 8rem;
}
.min-w-\\[900px\\] {
  min-width: 900px;
}
.min-w-\\[980px\\] {
  min-width: 980px;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
  min-width: var(--radix-select-trigger-width);
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[13rem\\] {
  max-width: 13rem;
}
.max-w-\\[160px\\] {
  max-width: 160px;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[220px\\] {
  max-width: 220px;
}
.max-w-\\[260px\\] {
  max-width: 260px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[320px\\] {
  max-width: 320px;
}
.max-w-\\[45\\%\\] {
  max-width: 45%;
}
.max-w-\\[55\\%\\] {
  max-width: 55%;
}
.max-w-\\[85\\%\\] {
  max-width: 85%;
}
.max-w-\\[88vw\\] {
  max-width: 88vw;
}
.max-w-\\[90vw\\] {
  max-width: 90vw;
}
.max-w-\\[92vw\\] {
  max-width: 92vw;
}
.max-w-\\[94\\%\\] {
  max-width: 94%;
}
.max-w-\\[calc\\(100vw-1\\.5rem\\)\\] {
  max-width: calc(100vw - 1.5rem);
}
.max-w-\\[calc\\(100vw-2rem\\)\\] {
  max-width: calc(100vw - 2rem);
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-max {
  max-width: max-content;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.grow {
  flex-grow: 1;
}
.grow-0 {
  flex-grow: 0;
}
.basis-full {
  flex-basis: 100%;
}
.table-fixed {
  table-layout: fixed;
}
.caption-bottom {
  caption-side: bottom;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\] {
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\] {
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\] {
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\] {
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\] {
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\] {
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\] {
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.origin-left {
  transform-origin: left;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-0\\.4deg\\] {
  --tw-rotate: -0.4deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.animate-\\[aislide_1\\.4s_ease-in-out_infinite\\] {
  animation: aislide 1.4s ease-in-out infinite;
}
@keyframes ping {

  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-cell {
  cursor: cell;
}
.cursor-crosshair {
  cursor: crosshair;
}
.cursor-default {
  cursor: default;
}
.cursor-grab {
  cursor: grab;
}
.cursor-help {
  cursor: help;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-text {
  cursor: text;
}
.touch-none {
  touch-action: none;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.select-all {
  -webkit-user-select: all;
          user-select: all;
}
.resize-y {
  resize: vertical;
}
.resize {
  resize: both;
}
.snap-x {
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.snap-center {
  scroll-snap-align: center;
}
.scroll-mt-20 {
  scroll-margin-top: 5rem;
}
.scroll-mt-24 {
  scroll-margin-top: 6rem;
}
.scroll-mt-28 {
  scroll-margin-top: 7rem;
}
.scroll-mt-40 {
  scroll-margin-top: 10rem;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-\\[1\\.2fr_1fr_1fr_0\\.7fr_0\\.7fr_auto\\] {
  grid-template-columns: 1.2fr 1fr 1fr 0.7fr 0.7fr auto;
}
.grid-cols-\\[1\\.2fr_1fr_1fr_92px_92px_auto_auto\\] {
  grid-template-columns: 1.2fr 1fr 1fr 92px 92px auto auto;
}
.grid-cols-\\[110px_1fr_1fr\\] {
  grid-template-columns: 110px 1fr 1fr;
}
.grid-cols-\\[120px_1fr_1fr\\] {
  grid-template-columns: 120px 1fr 1fr;
}
.grid-cols-\\[140px_1fr\\] {
  grid-template-columns: 140px 1fr;
}
.grid-cols-\\[140px_1fr_auto\\] {
  grid-template-columns: 140px 1fr auto;
}
.grid-cols-\\[180px_1fr\\] {
  grid-template-columns: 180px 1fr;
}
.grid-cols-\\[1fr_1\\.6fr_auto\\] {
  grid-template-columns: 1fr 1.6fr auto;
}
.grid-cols-\\[1fr_120px\\] {
  grid-template-columns: 1fr 120px;
}
.grid-cols-\\[1fr_130px\\] {
  grid-template-columns: 1fr 130px;
}
.grid-cols-\\[1fr_1fr_auto_auto\\] {
  grid-template-columns: 1fr 1fr auto auto;
}
.grid-cols-\\[1fr_auto_auto\\] {
  grid-template-columns: 1fr auto auto;
}
.grid-cols-\\[2fr_1fr_1fr\\] {
  grid-template-columns: 2fr 1fr 1fr;
}
.grid-cols-\\[84px_1fr_1fr\\] {
  grid-template-columns: 84px 1fr 1fr;
}
.grid-cols-\\[auto_140px_1fr\\] {
  grid-template-columns: auto 140px 1fr;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-items-center {
  place-items: center;
}
.content-start {
  align-content: flex-start;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[3px\\] {
  gap: 3px;
}
.gap-x-12 {
  column-gap: 3rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-y-0\\.5 {
  row-gap: 0.125rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-1\\.5 {
  row-gap: 0.375rem;
}
.gap-y-10 {
  row-gap: 2.5rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-2\\.5 {
  row-gap: 0.625rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3rem * var(--tw-space-y-reverse));
}
.space-y-16 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(4rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(4rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-amber-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-divide-opacity, 1));
}
.divide-amber-200\\/70 > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(253 230 138 / 0.7);
}
.divide-line\\/70 > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(var(--c-line) / 0.7);
}
.divide-red-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-divide-opacity, 1));
}
.divide-stone-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(245 245 244 / var(--tw-divide-opacity, 1));
}
.divide-stone-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(231 229 228 / var(--tw-divide-opacity, 1));
}
.self-start {
  align-self: flex-start;
}
.self-end {
  align-self: flex-end;
}
.self-center {
  align-self: center;
}
.justify-self-start {
  justify-self: start;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-full {
  border-radius: 9999px !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[1px\\] {
  border-radius: 1px;
}
.rounded-\\[2px\\] {
  border-radius: 2px;
}
.rounded-\\[inherit\\] {
  border-radius: inherit;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: var(--radius);
}
.rounded-md {
  border-radius: calc(var(--radius) - 2px);
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-lg {
  border-bottom-right-radius: var(--radius);
  border-bottom-left-radius: var(--radius);
}
.rounded-b-md {
  border-bottom-right-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.rounded-b-xl {
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-\\[10px\\] {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-t-md {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-top-right-radius: calc(var(--radius) - 2px);
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-tl-sm {
  border-top-left-radius: calc(var(--radius) - 4px);
}
.rounded-tr-sm {
  border-top-right-radius: calc(var(--radius) - 4px);
}
.\\!border-0 {
  border-width: 0px !important;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-t-\\[3px\\] {
  border-top-width: 3px;
}
.border-dashed {
  border-style: dashed;
}
.border-dotted {
  border-style: dotted;
}
.border-\\[\\#1d4f91\\] {
  --tw-border-opacity: 1;
  border-color: rgb(29 79 145 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1d4f91\\]\\/40 {
  border-color: rgb(29 79 145 / 0.4);
}
.border-\\[\\#2d6b0d\\] {
  --tw-border-opacity: 1;
  border-color: rgb(45 107 13 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2d6b0d\\]\\/20 {
  border-color: rgb(45 107 13 / 0.2);
}
.border-\\[\\#2d6b0d\\]\\/25 {
  border-color: rgb(45 107 13 / 0.25);
}
.border-\\[\\#2d6b0d\\]\\/30 {
  border-color: rgb(45 107 13 / 0.3);
}
.border-\\[\\#2d6b0d\\]\\/35 {
  border-color: rgb(45 107 13 / 0.35);
}
.border-\\[\\#2d6b0d\\]\\/40 {
  border-color: rgb(45 107 13 / 0.4);
}
.border-\\[\\#2d6b0d\\]\\/50 {
  border-color: rgb(45 107 13 / 0.5);
}
.border-\\[\\#2d6b0d\\]\\/60 {
  border-color: rgb(45 107 13 / 0.6);
}
.border-\\[\\#2f5a12\\]\\/40 {
  border-color: rgb(47 90 18 / 0.4);
}
.border-\\[\\#7aa73f\\] {
  --tw-border-opacity: 1;
  border-color: rgb(122 167 63 / var(--tw-border-opacity, 1));
}
.border-\\[\\#8a3b2f\\] {
  --tw-border-opacity: 1;
  border-color: rgb(138 59 47 / var(--tw-border-opacity, 1));
}
.border-\\[\\#cfe0bf\\] {
  --tw-border-opacity: 1;
  border-color: rgb(207 224 191 / var(--tw-border-opacity, 1));
}
.border-\\[\\#cfe3bf\\] {
  --tw-border-opacity: 1;
  border-color: rgb(207 227 191 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d9a63a\\] {
  --tw-border-opacity: 1;
  border-color: rgb(217 166 58 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d9a63a\\]\\/30 {
  border-color: rgb(217 166 58 / 0.3);
}
.border-\\[\\#d9a63a\\]\\/40 {
  border-color: rgb(217 166 58 / 0.4);
}
.border-\\[\\#d9a63a\\]\\/50 {
  border-color: rgb(217 166 58 / 0.5);
}
.border-\\[\\#d9a63a\\]\\/60 {
  border-color: rgb(217 166 58 / 0.6);
}
.border-\\[\\#d9a63a\\]\\/70 {
  border-color: rgb(217 166 58 / 0.7);
}
.border-\\[\\#e07b39\\]\\/40 {
  border-color: rgb(224 123 57 / 0.4);
}
.border-\\[\\#e1ecd6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(225 236 214 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e9c97a\\] {
  --tw-border-opacity: 1;
  border-color: rgb(233 201 122 / var(--tw-border-opacity, 1));
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-amber-300\\/60 {
  border-color: rgb(252 211 77 / 0.6);
}
.border-amber-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-black\\/5 {
  border-color: rgb(0 0 0 / 0.05);
}
.border-brand {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-brand) / var(--tw-border-opacity, 1));
}
.border-brand-deep {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-brand-deep) / var(--tw-border-opacity, 1));
}
.border-brand\\/15 {
  border-color: rgb(var(--c-brand) / 0.15);
}
.border-brand\\/40 {
  border-color: rgb(var(--c-brand) / 0.4);
}
.border-destructive {
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50 {
  border-color: hsl(var(--destructive) / 0.5);
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-300 {
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}
.border-input {
  border-color: hsl(var(--input));
}
.border-line {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-line) / var(--tw-border-opacity, 1));
}
.border-line\\/70 {
  border-color: rgb(var(--c-line) / 0.7);
}
.border-primary {
  border-color: hsl(var(--primary));
}
.border-primary\\/50 {
  border-color: hsl(var(--primary) / 0.5);
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-signal {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-signal) / var(--tw-border-opacity, 1));
}
.border-sky-200 {
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity, 1));
}
.border-sky-300 {
  --tw-border-opacity: 1;
  border-color: rgb(125 211 252 / var(--tw-border-opacity, 1));
}
.border-stone-100 {
  --tw-border-opacity: 1;
  border-color: rgb(245 245 244 / var(--tw-border-opacity, 1));
}
.border-stone-200 {
  --tw-border-opacity: 1;
  border-color: rgb(231 229 228 / var(--tw-border-opacity, 1));
}
.border-stone-200\\/60 {
  border-color: rgb(231 229 228 / 0.6);
}
.border-stone-300 {
  --tw-border-opacity: 1;
  border-color: rgb(214 211 209 / var(--tw-border-opacity, 1));
}
.border-stone-50 {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 249 / var(--tw-border-opacity, 1));
}
.border-stone-700 {
  --tw-border-opacity: 1;
  border-color: rgb(68 64 60 / var(--tw-border-opacity, 1));
}
.border-stone-800 {
  --tw-border-opacity: 1;
  border-color: rgb(41 37 36 / var(--tw-border-opacity, 1));
}
.border-tint {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-tint) / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-trash\\/30 {
  border-color: rgb(var(--c-trash) / 0.3);
}
.border-violet-300 {
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}
.border-violet-600 {
  --tw-border-opacity: 1;
  border-color: rgb(124 58 237 / var(--tw-border-opacity, 1));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-t-transparent {
  border-top-color: transparent;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.bg-\\[\\#0b0b0b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(11 11 11 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#183129\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(24 49 41 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1f4a0a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(31 74 10 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#25D366\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(37 211 102 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#25D366\\]\\/15 {
  background-color: rgb(37 211 102 / 0.15);
}
.bg-\\[\\#2d6b0d\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(45 107 13 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2d6b0d\\]\\/10 {
  background-color: rgb(45 107 13 / 0.1);
}
.bg-\\[\\#2d6b0d\\]\\/25 {
  background-color: rgb(45 107 13 / 0.25);
}
.bg-\\[\\#2d6b0d\\]\\/5 {
  background-color: rgb(45 107 13 / 0.05);
}
.bg-\\[\\#2d6b0d\\]\\/70 {
  background-color: rgb(45 107 13 / 0.7);
}
.bg-\\[\\#2f5a12\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(47 90 18 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#5b7fa6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(91 127 166 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#7aa73f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(122 167 63 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#a33a3a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(163 58 58 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#a8d6f4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(168 214 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#b23b3b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(178 59 59 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#b7cc8f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(183 204 143 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d05e65\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(208 94 101 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d9a63a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 166 58 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d9a63a\\]\\/20 {
  background-color: rgb(217 166 58 / 0.2);
}
.bg-\\[\\#d9a63a\\]\\/25 {
  background-color: rgb(217 166 58 / 0.25);
}
.bg-\\[\\#d9a63a\\]\\/30 {
  background-color: rgb(217 166 58 / 0.3);
}
.bg-\\[\\#dae8ce\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(218 232 206 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e07b39\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(224 123 57 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e8f1dd\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 241 221 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e8f3dc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 243 220 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eaf2ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 242 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eaf3e2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 243 226 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eaf3e2\\]\\/60 {
  background-color: rgb(234 243 226 / 0.6);
}
.bg-\\[\\#eef5e6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 245 230 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eef5e8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 245 232 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f3f7ee\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 247 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f3f7ee\\]\\/60 {
  background-color: rgb(243 247 238 / 0.6);
}
.bg-\\[\\#f3f8ee\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 248 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4f8ee\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 248 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4f8f0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 248 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4f9ee\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 249 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4f9ef\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 249 239 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6b3ad\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 179 173 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6f5f1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 245 241 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6faf2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 250 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f7faf3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 250 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f7faf4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 250 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8d58b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 213 139 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8fbf4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 251 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fbf3e1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 243 225 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fbf7ec\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 247 236 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fdf3dc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 243 220 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fdf3ec\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 243 236 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fdf6e3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 246 227 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fdf6e7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 246 231 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fff8c4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 248 196 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fffaf0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 250 240 / var(--tw-bg-opacity, 1));
}
.bg-accent {
  background-color: hsl(var(--accent));
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity, 1));
}
.bg-amber-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 211 77 / var(--tw-bg-opacity, 1));
}
.bg-amber-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-50\\/30 {
  background-color: rgb(255 251 235 / 0.3);
}
.bg-amber-50\\/40 {
  background-color: rgb(255 251 235 / 0.4);
}
.bg-amber-50\\/50 {
  background-color: rgb(255 251 235 / 0.5);
}
.bg-amber-50\\/60 {
  background-color: rgb(255 251 235 / 0.6);
}
.bg-amber-50\\/95 {
  background-color: rgb(255 251 235 / 0.95);
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-background {
  background-color: hsl(var(--background));
}
.bg-background\\/95 {
  background-color: hsl(var(--background) / 0.95);
}
.bg-badge-instant {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-badge-instant) / var(--tw-bg-opacity, 1));
}
.bg-badge-new {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-badge-new) / var(--tw-bg-opacity, 1));
}
.bg-badge-offer {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-badge-offer) / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/0 {
  background-color: rgb(0 0 0 / 0);
}
.bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/45 {
  background-color: rgb(0 0 0 / 0.45);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-border {
  background-color: hsl(var(--border));
}
.bg-brand {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-brand) / var(--tw-bg-opacity, 1));
}
.bg-brand-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-brand-dark) / var(--tw-bg-opacity, 1));
}
.bg-brand-deep {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-brand-deep) / var(--tw-bg-opacity, 1));
}
.bg-brand\\/15 {
  background-color: rgb(var(--c-brand) / 0.15);
}
.bg-brand\\/5 {
  background-color: rgb(var(--c-brand) / 0.05);
}
.bg-brand\\/75 {
  background-color: rgb(var(--c-brand) / 0.75);
}
.bg-brand\\/90 {
  background-color: rgb(var(--c-brand) / 0.9);
}
.bg-card {
  background-color: hsl(var(--card));
}
.bg-destructive {
  background-color: hsl(var(--destructive));
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(110 231 183 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-footer-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-footer-dark) / var(--tw-bg-opacity, 1));
}
.bg-footer-light {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-footer-light) / var(--tw-bg-opacity, 1));
}
.bg-footer-mid {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-footer-mid) / var(--tw-bg-opacity, 1));
}
.bg-foreground {
  background-color: hsl(var(--foreground));
}
.bg-gold {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gold) / var(--tw-bg-opacity, 1));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-50\\/40 {
  background-color: rgb(240 253 244 / 0.4);
}
.bg-muted {
  background-color: hsl(var(--muted));
}
.bg-muted\\/50 {
  background-color: hsl(var(--muted) / 0.5);
}
.bg-page {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-page) / var(--tw-bg-opacity, 1));
}
.bg-page\\/95 {
  background-color: rgb(var(--c-page) / 0.95);
}
.bg-popover {
  background-color: hsl(var(--popover));
}
.bg-primary {
  background-color: hsl(var(--primary));
}
.bg-primary\\/10 {
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20 {
  background-color: hsl(var(--primary) / 0.2);
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-50\\/40 {
  background-color: rgb(254 242 242 / 0.4);
}
.bg-red-50\\/50 {
  background-color: rgb(254 242 242 / 0.5);
}
.bg-red-50\\/60 {
  background-color: rgb(254 242 242 / 0.6);
}
.bg-red-50\\/95 {
  background-color: rgb(254 242 242 / 0.95);
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/60 {
  background-color: rgb(239 68 68 / 0.6);
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-red-600\\/80 {
  background-color: rgb(220 38 38 / 0.8);
}
.bg-red-600\\/90 {
  background-color: rgb(220 38 38 / 0.9);
}
.bg-secondary {
  background-color: hsl(var(--secondary));
}
.bg-signal {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-signal) / var(--tw-bg-opacity, 1));
}
.bg-signal\\/10 {
  background-color: rgb(var(--c-signal) / 0.1);
}
.bg-signal\\/60 {
  background-color: rgb(var(--c-signal) / 0.6);
}
.bg-sky-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-sky-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-sky-50\\/40 {
  background-color: rgb(240 249 255 / 0.4);
}
.bg-sky-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 105 161 / var(--tw-bg-opacity, 1));
}
.bg-soft {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-soft) / var(--tw-bg-opacity, 1));
}
.bg-soft\\/60 {
  background-color: rgb(var(--c-soft) / 0.6);
}
.bg-soft\\/80 {
  background-color: rgb(var(--c-soft) / 0.8);
}
.bg-stone-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 244 / var(--tw-bg-opacity, 1));
}
.bg-stone-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(231 229 228 / var(--tw-bg-opacity, 1));
}
.bg-stone-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(214 211 209 / var(--tw-bg-opacity, 1));
}
.bg-stone-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 162 158 / var(--tw-bg-opacity, 1));
}
.bg-stone-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 249 / var(--tw-bg-opacity, 1));
}
.bg-stone-50\\/60 {
  background-color: rgb(250 250 249 / 0.6);
}
.bg-stone-50\\/70 {
  background-color: rgb(250 250 249 / 0.7);
}
.bg-stone-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(120 113 108 / var(--tw-bg-opacity, 1));
}
.bg-stone-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(68 64 60 / var(--tw-bg-opacity, 1));
}
.bg-stone-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(41 37 36 / var(--tw-bg-opacity, 1));
}
.bg-stone-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(28 25 23 / var(--tw-bg-opacity, 1));
}
.bg-stone-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(12 10 9 / var(--tw-bg-opacity, 1));
}
.bg-tint {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-tint) / var(--tw-bg-opacity, 1));
}
.bg-tint\\/60 {
  background-color: rgb(var(--c-tint) / 0.6);
}
.bg-transparent {
  background-color: transparent;
}
.bg-trash\\/5 {
  background-color: rgb(var(--c-trash) / 0.05);
}
.bg-violet-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.bg-violet-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15 {
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/40 {
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/5 {
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/60 {
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/85 {
  background-color: rgb(255 255 255 / 0.85);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95 {
  background-color: rgb(255 255 255 / 0.95);
}
.bg-\\[linear-gradient\\(135deg\\2c \\#1f4a0a_0\\%\\2c \\#2d6b0d_55\\%\\2c \\#d9a63a_130\\%\\)\\] {
  background-image: linear-gradient(135deg,#1f4a0a 0%,#2d6b0d 55%,#d9a63a 130%);
}
.bg-\\[linear-gradient\\(135deg\\2c \\#9fb7c9\\2c \\#5b7d9a\\)\\] {
  background-image: linear-gradient(135deg,#9fb7c9,#5b7d9a);
}
.bg-\\[linear-gradient\\(to_bottom_right\\2c \\#fecaca_50\\%\\2c transparent_50\\%\\)\\] {
  background-image: linear-gradient(to bottom right,#fecaca 50%,transparent 50%);
}
.bg-\\[linear-gradient\\(to_bottom_right\\2c transparent_50\\%\\2c \\#fecaca_50\\%\\)\\] {
  background-image: linear-gradient(to bottom right,transparent 50%,#fecaca 50%);
}
.bg-\\[radial-gradient\\(circle_at_80\\%_20\\%\\2c \\#fff_0\\2c transparent_40\\%\\)\\] {
  background-image: radial-gradient(circle at 80% 20%,#fff 0,transparent 40%);
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-black\\/50 {
  --tw-gradient-from: rgb(0 0 0 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/60 {
  --tw-gradient-from: rgb(0 0 0 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/70 {
  --tw-gradient-from: rgb(0 0 0 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-page {
  --tw-gradient-from: rgb(var(--c-page) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--c-page) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-black\\/10 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/20 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-page\\/85 {
  --tw-gradient-to: rgb(var(--c-page) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--c-page) / 0.85) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-black\\/60 {
  --tw-gradient-to: rgb(0 0 0 / 0.6) var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-white\\/40 {
  --tw-gradient-to: rgb(255 255 255 / 0.4) var(--tw-gradient-to-position);
}
.bg-cover {
  background-size: cover;
}
.bg-center {
  background-position: center;
}
.fill-\\[\\#d9a63a\\] {
  fill: #d9a63a;
}
.fill-amber-400 {
  fill: #fbbf24;
}
.fill-current {
  fill: currentColor;
}
.fill-gold {
  fill: rgb(var(--c-gold) / 1);
}
.fill-primary {
  fill: hsl(var(--primary));
}
.fill-red-600 {
  fill: #dc2626;
}
.fill-signal {
  fill: rgb(var(--c-signal) / 1);
}
.fill-white {
  fill: #fff;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-12 {
  padding: 3rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-20 {
  padding: 5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[1px\\] {
  padding: 1px;
}
.\\!px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.\\!py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-32 {
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-px {
  padding-top: 1px;
  padding-bottom: 1px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-0\\.5 {
  padding-bottom: 0.125rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-14 {
  padding-bottom: 3.5rem;
}
.pb-16 {
  padding-bottom: 4rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-28 {
  padding-bottom: 7rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-1\\.5 {
  padding-left: 0.375rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-1\\.5 {
  padding-right: 0.375rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-2\\.5 {
  padding-right: 0.625rem;
}
.pr-24 {
  padding-right: 6rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pr-9 {
  padding-right: 2.25rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-14 {
  padding-top: 3.5rem;
}
.pt-16 {
  padding-top: 4rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-32 {
  padding-top: 8rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.align-bottom {
  vertical-align: bottom;
}
.align-\\[-1px\\] {
  vertical-align: -1px;
}
.font-\\[inherit\\] {
  font-family: inherit;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.font-serif {
  font-family: ui-serif, Georgia, Cambria, "Times New Roman", Times, serif;
}
.text-2xl {
  font-size: calc(1.5rem * var(--hs, 1));
  line-height: 1.3333;
}
.text-3xl {
  font-size: calc(1.875rem * var(--hs, 1));
  line-height: 1.2;
}
.text-4xl {
  font-size: calc(2.25rem * var(--hs, 1));
  line-height: 1.1111;
}
.text-6xl {
  font-size: calc(3.75rem * var(--hs, 1));
  line-height: 1;
}
.text-\\[0\\.8rem\\] {
  font-size: 0.8rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[5px\\] {
  font-size: 5px;
}
.text-\\[6px\\] {
  font-size: 6px;
}
.text-\\[8px\\] {
  font-size: 8px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.normal-case {
  text-transform: none;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-\\[1\\.1\\] {
  line-height: 1.1;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.12em\\] {
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.25em\\] {
  letter-spacing: 0.25em;
}
.tracking-\\[0\\.2em\\] {
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.3em\\] {
  letter-spacing: 0.3em;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-\\[\\#128C4A\\] {
  --tw-text-opacity: 1;
  color: rgb(18 140 74 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1877F2\\] {
  --tw-text-opacity: 1;
  color: rgb(24 119 242 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1a0dab\\] {
  --tw-text-opacity: 1;
  color: rgb(26 13 171 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1d4f91\\] {
  --tw-text-opacity: 1;
  color: rgb(29 79 145 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1e4a08\\] {
  --tw-text-opacity: 1;
  color: rgb(30 74 8 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1f4a0a\\] {
  --tw-text-opacity: 1;
  color: rgb(31 74 10 / var(--tw-text-opacity, 1));
}
.text-\\[\\#25D366\\] {
  --tw-text-opacity: 1;
  color: rgb(37 211 102 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2d6b0d\\] {
  --tw-text-opacity: 1;
  color: rgb(45 107 13 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2f5a12\\] {
  --tw-text-opacity: 1;
  color: rgb(47 90 18 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7a5a10\\] {
  --tw-text-opacity: 1;
  color: rgb(122 90 16 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8a3b2f\\] {
  --tw-text-opacity: 1;
  color: rgb(138 59 47 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8a6410\\] {
  --tw-text-opacity: 1;
  color: rgb(138 100 16 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8a6a17\\] {
  --tw-text-opacity: 1;
  color: rgb(138 106 23 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8a6a1f\\] {
  --tw-text-opacity: 1;
  color: rgb(138 106 31 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8f6a14\\] {
  --tw-text-opacity: 1;
  color: rgb(143 106 20 / var(--tw-text-opacity, 1));
}
.text-\\[\\#b8860b\\] {
  --tw-text-opacity: 1;
  color: rgb(184 134 11 / var(--tw-text-opacity, 1));
}
.text-\\[\\#d00000\\] {
  --tw-text-opacity: 1;
  color: rgb(208 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#d05e65\\] {
  --tw-text-opacity: 1;
  color: rgb(208 94 101 / var(--tw-text-opacity, 1));
}
.text-\\[\\#d9a63a\\] {
  --tw-text-opacity: 1;
  color: rgb(217 166 58 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f0b400\\] {
  --tw-text-opacity: 1;
  color: rgb(240 180 0 / var(--tw-text-opacity, 1));
}
.text-accent-foreground {
  color: hsl(var(--accent-foreground));
}
.text-amber-400 {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-600\\/80 {
  color: rgb(217 119 6 / 0.8);
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-800\\/70 {
  color: rgb(146 64 14 / 0.7);
}
.text-amber-800\\/80 {
  color: rgb(146 64 14 / 0.8);
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-badge-offer {
  --tw-text-opacity: 1;
  color: rgb(var(--c-badge-offer) / var(--tw-text-opacity, 1));
}
.text-brand {
  --tw-text-opacity: 1;
  color: rgb(var(--c-brand) / var(--tw-text-opacity, 1));
}
.text-brand-deep {
  --tw-text-opacity: 1;
  color: rgb(var(--c-brand-deep) / var(--tw-text-opacity, 1));
}
.text-brand\\/40 {
  color: rgb(var(--c-brand) / 0.4);
}
.text-card-foreground {
  color: hsl(var(--card-foreground));
}
.text-current {
  color: currentColor;
}
.text-destructive {
  color: hsl(var(--destructive));
}
.text-destructive-foreground {
  color: hsl(var(--destructive-foreground));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900 {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-footer-dark {
  --tw-text-opacity: 1;
  color: rgb(var(--c-footer-dark) / var(--tw-text-opacity, 1));
}
.text-foreground {
  color: hsl(var(--foreground));
}
.text-foreground\\/50 {
  color: hsl(var(--foreground) / 0.5);
}
.text-gold {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gold) / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}
.text-line {
  --tw-text-opacity: 1;
  color: rgb(var(--c-line) / var(--tw-text-opacity, 1));
}
.text-muted-foreground {
  color: hsl(var(--muted-foreground));
}
.text-popover-foreground {
  color: hsl(var(--popover-foreground));
}
.text-primary {
  color: hsl(var(--primary));
}
.text-primary-foreground {
  color: hsl(var(--primary-foreground));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-700\\/70 {
  color: rgb(185 28 28 / 0.7);
}
.text-red-700\\/80 {
  color: rgb(185 28 28 / 0.8);
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.text-red-900\\/70 {
  color: rgb(127 29 29 / 0.7);
}
.text-secondary-foreground {
  color: hsl(var(--secondary-foreground));
}
.text-signal {
  --tw-text-opacity: 1;
  color: rgb(var(--c-signal) / var(--tw-text-opacity, 1));
}
.text-sky-500 {
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity, 1));
}
.text-sky-600 {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}
.text-sky-700 {
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}
.text-sky-800 {
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}
.text-stone-300 {
  --tw-text-opacity: 1;
  color: rgb(214 211 209 / var(--tw-text-opacity, 1));
}
.text-stone-400 {
  --tw-text-opacity: 1;
  color: rgb(168 162 158 / var(--tw-text-opacity, 1));
}
.text-stone-500 {
  --tw-text-opacity: 1;
  color: rgb(120 113 108 / var(--tw-text-opacity, 1));
}
.text-stone-600 {
  --tw-text-opacity: 1;
  color: rgb(87 83 78 / var(--tw-text-opacity, 1));
}
.text-stone-700 {
  --tw-text-opacity: 1;
  color: rgb(68 64 60 / var(--tw-text-opacity, 1));
}
.text-stone-800 {
  --tw-text-opacity: 1;
  color: rgb(41 37 36 / var(--tw-text-opacity, 1));
}
.text-stone-900 {
  --tw-text-opacity: 1;
  color: rgb(28 25 23 / var(--tw-text-opacity, 1));
}
.text-sun {
  --tw-text-opacity: 1;
  color: rgb(var(--c-sun) / var(--tw-text-opacity, 1));
}
.text-transparent {
  color: transparent;
}
.text-trash {
  --tw-text-opacity: 1;
  color: rgb(var(--c-trash) / var(--tw-text-opacity, 1));
}
.text-violet-500 {
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.text-violet-600 {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.text-violet-700 {
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.text-violet-800 {
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/60 {
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85 {
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.no-underline {
  text-decoration-line: none;
}
.decoration-\\[\\#d9a63a\\] {
  text-decoration-color: #d9a63a;
}
.decoration-stone-400 {
  text-decoration-color: #a8a29e;
}
.decoration-dotted {
  text-decoration-style: dotted;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.accent-\\[\\#2d6b0d\\] {
  accent-color: #2d6b0d;
}
.accent-brand {
  accent-color: rgb(var(--c-brand) / 1);
}
.accent-red-600 {
  accent-color: #dc2626;
}
.accent-violet-600 {
  accent-color: #7c3aed;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[2px_3px_10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.12\\)\\] {
  --tw-shadow: 2px 3px 10px rgba(0,0,0,0.12);
  --tw-shadow-colored: 2px 3px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-black\\/20 {
  --tw-shadow-color: rgb(0 0 0 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.outline-2 {
  outline-width: 2px;
}
.outline-offset-1 {
  outline-offset: 1px;
}
.outline-\\[\\#2d6b0d\\]\\/40 {
  outline-color: rgb(45 107 13 / 0.4);
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[\\#2d6b0d\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(45 107 13 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#2d6b0d\\]\\/30 {
  --tw-ring-color: rgb(45 107 13 / 0.3);
}
.ring-\\[\\#2d6b0d\\]\\/40 {
  --tw-ring-color: rgb(45 107 13 / 0.4);
}
.ring-\\[\\#d9a63a\\]\\/60 {
  --tw-ring-color: rgb(217 166 58 / 0.6);
}
.ring-amber-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 211 77 / var(--tw-ring-opacity, 1));
}
.ring-amber-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 191 36 / var(--tw-ring-opacity, 1));
}
.ring-brand {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--c-brand) / var(--tw-ring-opacity, 1));
}
.ring-brand\\/40 {
  --tw-ring-color: rgb(var(--c-brand) / 0.4);
}
.ring-red-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.ring-ring {
  --tw-ring-color: hsl(var(--ring));
}
.ring-stone-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(214 211 209 / var(--tw-ring-opacity, 1));
}
.ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-offset-2 {
  --tw-ring-offset-width: 2px;
}
.ring-offset-4 {
  --tw-ring-offset-width: 4px;
}
.ring-offset-background {
  --tw-ring-offset-color: hsl(var(--background));
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-2xl {
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl {
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-sm {
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[1px\\] {
  --tw-backdrop-blur: blur(1px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[grid-template-rows\\] {
  transition-property: grid-template-rows;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[height\\] {
  transition-property: height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c background-color\\] {
  transition-property: transform,background-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\] {
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
@keyframes enter {

  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit {

  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0 {
  --tw-enter-opacity: 0;
}
.zoom-in-95 {
  --tw-enter-scale: .95;
}
.duration-1000 {
  animation-duration: 1000ms;
}
.duration-200 {
  animation-duration: 200ms;
}
.duration-300 {
  animation-duration: 300ms;
}
.duration-500 {
  animation-duration: 500ms;
}
.ease-in-out {
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\!running {
  animation-play-state: running !important;
}
.running {
  animation-play-state: running;
}
.\\[scrollbar-width\\:none\\] {
  scrollbar-width: none;
}
.\\[touch-action\\:pan-y\\] {
  touch-action: pan-y;
}

/* Ersatzschriften mit angepassten Metriken: Text steht vor dem Webfont fast deckungsgleich (kein Sprung beim Font-Wechsel) */
@font-face { font-family: "Open Sans Fallback"; src: local("Arial"); size-adjust: 105.64%; ascent-override: 101.18%; descent-override: 27.73%; line-gap-override: 0%; }
@font-face { font-family: "Inter Fallback"; src: local("Arial"); size-adjust: 107.64%; ascent-override: 90.49%; descent-override: 22.56%; line-gap-override: 0%; }


/* Design-Standardwerte (Admin → Design überschreibt sie per Inline-Variablen am <html>) */
:root {
  --c-brand: 45 107 13; --c-brand-hover: 30 74 8; --c-brand-dark: 36 86 9; --c-brand-deep: 47 90 18;
  --c-gold: 217 166 58; --c-sun: 240 180 0; --c-signal: 208 0 0;
  --c-line: 207 224 191; --c-soft: 218 232 206; --c-tint: 243 247 238; --c-page: 247 250 243; --c-ink: 51 51 51;
  --c-footer-light: 183 204 143; --c-footer-mid: 87 130 38; --c-footer-dark: 51 107 15; --c-trash: 185 28 28;
  --c-badge-offer: 208 0 0; --c-badge-instant: 45 107 13; --c-badge-new: 217 166 58;
  --font-body: "Open Sans"; --font-heading: "Open Sans"; --font-heading-weight: 600; --font-base: 16px;
  --hs-all: 1; --h1s: 1; --h2s: 1; --h3s: 1; --hs: var(--hs-all);
  --header-bg: 250 248 245; --header-bg-a: 0.82; --header-blur: 14px; --header-h: 80px;
  --home-sec-py: 2.5rem; --home-sec-head: 1.5rem;
}

/* Abschnitte der Startseite (Admin → Design → Startseite → Abschnittsabstand) */
.home-section { padding-top: var(--home-sec-py); padding-bottom: var(--home-sec-py); }
.home-section-half { padding-top: 0; padding-bottom: calc(var(--home-sec-py) / 2); }
.home-section-heading { padding-top: var(--home-sec-py); padding-bottom: 0; margin-bottom: var(--home-sec-head); }
.home-section-head { margin-bottom: var(--home-sec-head); }
@media (max-width: 767px) { .home-section { padding-top: calc(var(--home-sec-py) * 0.8); padding-bottom: calc(var(--home-sec-py) * 0.8); } }
/* Abschnitte außerhalb des Sichtbereichs erst rendern, wenn sie näher kommen: spart Layout/Paint bei jedem Datenupdate (Inhalt bleibt im DOM, SEO unverändert) */
.home-section, footer[data-testid="site-footer"] { content-visibility: auto; contain-intrinsic-size: auto 800px; }
/* Platzhalterhöhe muss ≥ echter Höhe sein, sonst ragen ungerenderte Karten rechnerisch in den Folgeabschnitt (axe „target obscured“) */
@media (max-width: 767px) {
  .home-section, footer[data-testid="site-footer"] { contain-intrinsic-size: auto 1400px; }
  .home-section[data-testid="featured-section"] { contain-intrinsic-size: auto 2600px; }
  .home-section[data-testid="new-properties-section"], .home-section[data-testid="home-tips"], .home-section[data-testid="home-complexes"] { contain-intrinsic-size: auto 2000px; }
  footer[data-testid="site-footer"] { contain-intrinsic-size: auto 2400px; }
}

html { font-size: var(--font-base); }
/* Überschriften-Größe je Ebene (Admin → Design → Schrift): Tailwind text-*xl rechnet mit --hs */
h1 { --hs: calc(var(--hs-all) * var(--h1s)); }
h2 { --hs: calc(var(--hs-all) * var(--h2s)); }
h3 { --hs: calc(var(--hs-all) * var(--h3s)); }

body {
  margin: 0;
  font-family: var(--font-body), "Open Sans", "Open Sans Fallback", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: rgb(var(--c-page));
  color: rgb(var(--c-ink));
}

.font-serif {
  font-family: var(--font-heading), "Open Sans", "Open Sans Fallback", Helvetica, Arial, sans-serif !important;
  font-weight: var(--font-heading-weight);
  letter-spacing: -0.01em;
}

.hero-gradient-overlay {
  background: linear-gradient(135deg, rgba(14, 75, 117, 0.55) 0%, rgba(28, 25, 23, 0.35) 60%, rgba(217, 107, 67, 0.2) 100%);
}

/* Titelbild: feste, vom Inhalt unabhängige Höhe (Handy 115vh, Desktop = Hero-Mindesthöhe), damit die statische Hülle aus index.html
   vor React pixelgleich dasselbe zeigt; der Abschnitt schneidet per overflow:hidden ab */
.hero-img { position: absolute; top: 0; left: 0; width: 100%; height: max(100%, var(--hero-h, 92vh)); object-fit: cover; }
@media (max-width: 767px) { .hero-img { height: max(100%, 115vh); } }

.glass-header {
  background: rgb(var(--header-bg) / var(--header-bg-a));
  backdrop-filter: blur(var(--header-blur));
  -webkit-backdrop-filter: blur(var(--header-blur));
  border-bottom: 1px solid rgba(28, 25, 23, 0.06);
}

.card-hover {
  transition: transform 0.4s cubic-bezier(0.2, 0.9, 0.3, 1), box-shadow 0.4s ease;
}
.card-hover:hover { transform: translateY(-4px); box-shadow: 0 24px 48px -20px rgba(14, 75, 117, 0.25); }

.img-hover-zoom img {
  transition: transform 0.7s cubic-bezier(0.2, 0.9, 0.3, 1);
}
.img-hover-zoom:hover img { transform: scale(1.06); }

.grain::before {
  content: "";
  position: absolute; inset: 0;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2'/><feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>");
  pointer-events: none;
  opacity: 0.6;
  mix-blend-mode: multiply;
}

/* Schmale Scrollleiste für die Buchungsbox (Objektseite) */
.scrollbar-thin { scrollbar-width: thin; scrollbar-color: rgba(45, 107, 13, 0.35) transparent; }
.scrollbar-thin::-webkit-scrollbar { width: 6px; }
.scrollbar-thin::-webkit-scrollbar-thumb { background: rgba(45, 107, 13, 0.35); border-radius: 9999px; }


/* Objektkarte: Hover-Kärtchen ohne Spitze, wenn es seitlich/unten versetzt angezeigt wird */
.ph-pop-notip .leaflet-popup-tip-container { display: none; }
/* Verschiebbarer Marker im Objektformular (LocationPicker): Touch/Pointer-Drag ohne Seitenscroll, deutlicher Greifcursor */
.ph-drag-marker { touch-action: none !important; -webkit-user-select: none; user-select: none; -webkit-touch-callout: none; cursor: grab !important; pointer-events: auto !important; }
.leaflet-dragging .ph-drag-marker { cursor: grabbing !important; }
/* Mobil: Chat-Knopf über die feste „Jetzt buchen“-Leiste der Objektseite heben, damit er den Knopf nicht verdeckt */
@media (max-width: 767px) { body:has([data-testid="mobile-booking-bar"]) [data-testid="chat-open-btn"] { bottom: 5.5rem; width: 3rem; height: 3rem; right: 1rem; } }
/* Bild-Badge „Neu“: minimale Abdunklung (8 %), damit weiße 10-px-Schrift auch bei hellen Wunschfarben ≥ 4,5:1 erreicht */
.bg-badge-new { background-image: linear-gradient(rgba(0,0,0,.08), rgba(0,0,0,.08)); }

/* Vermieter-Homepage: neutrale Schriftvarianten (keine zusätzlichen Webfonts) */
.site-font-classic { font-family: Georgia, "Times New Roman", serif; }
.site-font-modern { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; }
.site-font-warm { font-family: "Trebuchet MS", Verdana, "Segoe UI", sans-serif; }
.file\\:border-0::file-selector-button {
  border-width: 0px;
}
.file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}
.file\\:text-sm::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-medium::file-selector-button {
  font-weight: 500;
}
.file\\:text-foreground::file-selector-button {
  color: hsl(var(--foreground));
}
.placeholder\\:text-amber-700\\/50::placeholder {
  color: rgb(180 83 9 / 0.5);
}
.placeholder\\:text-muted-foreground::placeholder {
  color: hsl(var(--muted-foreground));
}
.placeholder\\:text-stone-400::placeholder {
  --tw-text-opacity: 1;
  color: rgb(168 162 158 / var(--tw-text-opacity, 1));
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-y-0::after {
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}
.after\\:left-1\\/2::after {
  content: var(--tw-content);
  left: 50%;
}
.after\\:w-1::after {
  content: var(--tw-content);
  width: 0.25rem;
}
.after\\:-translate-x-1\\/2::after {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.first\\:rounded-l-md:first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.first\\:border-l:first-child {
  border-left-width: 1px;
}
.first\\:border-t-0:first-child {
  border-top-width: 0px;
}
.last\\:flex-none:last-child {
  flex: none;
}
.last\\:rounded-r-md:last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.last\\:border-0:last-child {
  border-width: 0px;
}
.odd\\:bg-\\[\\#f7faf3\\]:nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgb(247 250 243 / var(--tw-bg-opacity, 1));
}
.empty\\:hidden:empty {
  display: none;
}
.focus-within\\:relative:focus-within {
  position: relative;
}
.focus-within\\:z-20:focus-within {
  z-index: 20;
}
.hover\\:-translate-y-0\\.5:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:gap-2:hover {
  gap: 0.5rem;
}
.hover\\:gap-2\\.5:hover {
  gap: 0.625rem;
}
.hover\\:border-\\[\\#2d6b0d\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(45 107 13 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#7aa73f\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(122 167 63 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#cfe0bf\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(207 224 191 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#d9a63a\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(217 166 58 / var(--tw-border-opacity, 1));
}
.hover\\:border-amber-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.hover\\:border-brand:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-brand) / var(--tw-border-opacity, 1));
}
.hover\\:border-brand\\/50:hover {
  border-color: rgb(var(--c-brand) / 0.5);
}
.hover\\:border-red-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.hover\\:border-signal\\/60:hover {
  border-color: rgb(var(--c-signal) / 0.6);
}
.hover\\:border-stone-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(214 211 209 / var(--tw-border-opacity, 1));
}
.hover\\:border-stone-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(168 162 158 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#1e4a08\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 74 8 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1ebe5b\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 190 91 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#245608\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(36 86 8 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#245609\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(36 86 9 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#24560a\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(36 86 10 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#245709\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(36 87 9 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#25D366\\]\\/30:hover {
  background-color: rgb(37 211 102 / 0.3);
}
.hover\\:bg-\\[\\#2d6b0d\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(45 107 13 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2d6b0d\\]\\/5:hover {
  background-color: rgb(45 107 13 / 0.05);
}
.hover\\:bg-\\[\\#7aa73f\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(122 167 63 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#962f2f\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(150 47 47 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#b7cc8f\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(183 204 143 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#b84a51\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(184 74 81 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#c4922c\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(196 146 44 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#c4952f\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(196 149 47 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#c9dcb9\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(201 220 185 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#d05e65\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(208 94 101 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#d9a63a\\]\\/10:hover {
  background-color: rgb(217 166 58 / 0.1);
}
.hover\\:bg-\\[\\#d9a63a\\]\\/15:hover {
  background-color: rgb(217 166 58 / 0.15);
}
.hover\\:bg-\\[\\#dae8ce\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(218 232 206 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#e8f3dc\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(232 243 220 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#e8f3e0\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(232 243 224 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#eaf3e2\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 243 226 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f3e7c8\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 231 200 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f3f7ee\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 247 238 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f3f7ee\\]\\/60:hover {
  background-color: rgb(243 247 238 / 0.6);
}
.hover\\:bg-\\[\\#f3f8ee\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 248 238 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f4f9ee\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 249 238 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#fbf7ec\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 247 236 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-accent:hover {
  background-color: hsl(var(--accent));
}
.hover\\:bg-amber-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-badge-instant:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-badge-instant) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-badge-new:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-badge-new) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-badge-offer:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-badge-offer) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-black\\/25:hover {
  background-color: rgb(0 0 0 / 0.25);
}
.hover\\:bg-brand:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-brand) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-dark:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-brand-dark) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-deep:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-brand-deep) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-hover:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-brand-hover) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-destructive\\/80:hover {
  background-color: hsl(var(--destructive) / 0.8);
}
.hover\\:bg-destructive\\/90:hover {
  background-color: hsl(var(--destructive) / 0.9);
}
.hover\\:bg-footer-dark:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-footer-dark) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-muted:hover {
  background-color: hsl(var(--muted));
}
.hover\\:bg-muted\\/50:hover {
  background-color: hsl(var(--muted) / 0.5);
}
.hover\\:bg-primary:hover {
  background-color: hsl(var(--primary));
}
.hover\\:bg-primary\\/80:hover {
  background-color: hsl(var(--primary) / 0.8);
}
.hover\\:bg-primary\\/90:hover {
  background-color: hsl(var(--primary) / 0.9);
}
.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-secondary:hover {
  background-color: hsl(var(--secondary));
}
.hover\\:bg-secondary\\/80:hover {
  background-color: hsl(var(--secondary) / 0.8);
}
.hover\\:bg-sky-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-soft:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-soft) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-stone-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 244 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-stone-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(231 229 228 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-stone-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(168 162 158 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-stone-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-stone-50\\/60:hover {
  background-color: rgb(250 250 249 / 0.6);
}
.hover\\:bg-stone-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(41 37 36 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-tint:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-tint) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-trash\\/10:hover {
  background-color: rgb(var(--c-trash) / 0.1);
}
.hover\\:bg-violet-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-violet-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(109 40 217 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-white\\/30:hover {
  background-color: rgb(255 255 255 / 0.3);
}
.hover\\:text-\\[\\#1e4a08\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(30 74 8 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#2d6b0d\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(45 107 13 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#d9a63a\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(217 166 58 / var(--tw-text-opacity, 1));
}
.hover\\:text-accent-foreground:hover {
  color: hsl(var(--accent-foreground));
}
.hover\\:text-amber-700:hover {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-950:hover {
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity, 1));
}
.hover\\:text-brand:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-brand) / var(--tw-text-opacity, 1));
}
.hover\\:text-brand-dark:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-brand-dark) / var(--tw-text-opacity, 1));
}
.hover\\:text-brand-hover:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-brand-hover) / var(--tw-text-opacity, 1));
}
.hover\\:text-foreground:hover {
  color: hsl(var(--foreground));
}
.hover\\:text-muted-foreground:hover {
  color: hsl(var(--muted-foreground));
}
.hover\\:text-primary-foreground:hover {
  color: hsl(var(--primary-foreground));
}
.hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-800:hover {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.hover\\:text-signal\\/80:hover {
  color: rgb(var(--c-signal) / 0.8);
}
.hover\\:text-sky-900:hover {
  --tw-text-opacity: 1;
  color: rgb(12 74 110 / var(--tw-text-opacity, 1));
}
.hover\\:text-stone-500:hover {
  --tw-text-opacity: 1;
  color: rgb(120 113 108 / var(--tw-text-opacity, 1));
}
.hover\\:text-stone-600:hover {
  --tw-text-opacity: 1;
  color: rgb(87 83 78 / var(--tw-text-opacity, 1));
}
.hover\\:text-stone-700:hover {
  --tw-text-opacity: 1;
  color: rgb(68 64 60 / var(--tw-text-opacity, 1));
}
.hover\\:text-stone-800:hover {
  --tw-text-opacity: 1;
  color: rgb(41 37 36 / var(--tw-text-opacity, 1));
}
.hover\\:text-stone-900:hover {
  --tw-text-opacity: 1;
  color: rgb(28 25 23 / var(--tw-text-opacity, 1));
}
.hover\\:text-trash:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-trash) / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:decoration-solid:hover {
  text-decoration-style: solid;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:opacity-80:hover {
  opacity: 0.8;
}
.hover\\:opacity-90:hover {
  opacity: 0.9;
}
.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-sm:hover {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:ring-1:hover {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.hover\\:ring-2:hover {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.hover\\:ring-\\[\\#2d6b0d\\]:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(45 107 13 / var(--tw-ring-opacity, 1));
}
.hover\\:ring-\\[\\#d9a63a\\]:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(217 166 58 / var(--tw-ring-opacity, 1));
}
.hover\\:ring-brand\\/40:hover {
  --tw-ring-color: rgb(var(--c-brand) / 0.4);
}
.hover\\:ring-red-400:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.hover\\:ring-stone-200:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(231 229 228 / var(--tw-ring-opacity, 1));
}
.hover\\:ring-stone-300:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(214 211 209 / var(--tw-ring-opacity, 1));
}
.hover\\:brightness-110:hover {
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.focus\\:bg-accent:focus {
  background-color: hsl(var(--accent));
}
.focus\\:bg-brand:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-brand) / var(--tw-bg-opacity, 1));
}
.focus\\:bg-primary:focus {
  background-color: hsl(var(--primary));
}
.focus\\:text-accent-foreground:focus {
  color: hsl(var(--accent-foreground));
}
.focus\\:text-primary-foreground:focus {
  color: hsl(var(--primary-foreground));
}
.focus\\:text-white:focus {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.focus\\:opacity-100:focus {
  opacity: 1;
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[\\#2d6b0d\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(45 107 13 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#2d6b0d\\]\\/30:focus {
  --tw-ring-color: rgb(45 107 13 / 0.3);
}
.focus\\:ring-\\[color\\:var\\(--site-accent\\)\\]:focus {
  --tw-ring-color: var(--site-accent);
}
.focus\\:ring-ring:focus {
  --tw-ring-color: hsl(var(--ring));
}
.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:underline:focus-visible {
  text-decoration-line: underline;
}
.focus-visible\\:opacity-100:focus-visible {
  opacity: 1;
}
.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-1:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-ring:focus-visible {
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-offset-1:focus-visible {
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background:focus-visible {
  --tw-ring-offset-color: hsl(var(--background));
}
.active\\:cursor-grabbing:active {
  cursor: grabbing;
}
.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:no-underline:disabled {
  text-decoration-line: none;
}
.disabled\\:opacity-20:disabled {
  opacity: 0.2;
}
.disabled\\:opacity-30:disabled {
  opacity: 0.3;
}
.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}
.group:hover .group-hover\\:translate-x-0\\.5 {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:-rotate-2 {
  --tw-rotate: -2deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-\\[1\\.03\\] {
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:gap-2 {
  gap: 0.5rem;
}
.group:hover .group-hover\\:bg-\\[\\#2d6b0d\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(45 107 13 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-black\\/35 {
  background-color: rgb(0 0 0 / 0.35);
}
.group:hover .group-hover\\:bg-brand {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-brand) / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:text-brand {
  --tw-text-opacity: 1;
  color: rgb(var(--c-brand) / var(--tw-text-opacity, 1));
}
.group\\/row:hover .group-hover\\/row\\:opacity-100 {
  opacity: 1;
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.group:hover .group-hover\\:opacity-90 {
  opacity: 0.9;
}
.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40 {
  border-color: hsl(var(--muted) / 0.4);
}
.group.toaster .group-\\[\\.toaster\\]\\:border-border {
  border-color: hsl(var(--border));
}
.group.toast .group-\\[\\.toast\\]\\:bg-muted {
  background-color: hsl(var(--muted));
}
.group.toast .group-\\[\\.toast\\]\\:bg-primary {
  background-color: hsl(var(--primary));
}
.group.toaster .group-\\[\\.toaster\\]\\:bg-background {
  background-color: hsl(var(--background));
}
.group.destructive .group-\\[\\.destructive\\]\\:text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground {
  color: hsl(var(--muted-foreground));
}
.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground {
  color: hsl(var(--primary-foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:text-foreground {
  color: hsl(var(--foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover {
  border-color: hsl(var(--destructive) / 0.3);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover {
  background-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover {
  color: hsl(var(--destructive-foreground));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover {
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus {
  --tw-ring-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus {
  --tw-ring-offset-color: #dc2626;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed {
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70 {
  opacity: 0.7;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled) {
  opacity: 0.5;
}
.aria-selected\\:bg-accent[aria-selected="true"] {
  background-color: hsl(var(--accent));
}
.aria-selected\\:bg-accent\\/50[aria-selected="true"] {
  background-color: hsl(var(--accent) / 0.5);
}
.aria-selected\\:bg-soft[aria-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-soft) / var(--tw-bg-opacity, 1));
}
.aria-selected\\:bg-none[aria-selected="true"] {
  background-image: none;
}
.aria-selected\\:text-accent-foreground[aria-selected="true"] {
  color: hsl(var(--accent-foreground));
}
.aria-selected\\:text-muted-foreground[aria-selected="true"] {
  color: hsl(var(--muted-foreground));
}
.aria-selected\\:text-stone-900[aria-selected="true"] {
  --tw-text-opacity: 1;
  color: rgb(28 25 23 / var(--tw-text-opacity, 1));
}
.aria-selected\\:opacity-100[aria-selected="true"] {
  opacity: 1;
}
.aria-\\[selected\\=false\\]\\:bg-brand\\/15[aria-selected="false"] {
  background-color: rgb(var(--c-brand) / 0.15);
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"] {
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
  pointer-events: none;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"] {
  height: 1px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"] {
  width: 100%;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"] {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"] {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"] {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"] {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"] {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"] {
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"] {
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes accordion-up {

  from {
    height: var(--radix-accordion-content-height);
  }

  to {
    height: 0;
  }
}
.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"] {
  animation: accordion-up 0.2s ease-out;
}
@keyframes accordion-down {

  from {
    height: 0;
  }

  to {
    height: var(--radix-accordion-content-height);
  }
}
.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"] {
  animation: accordion-down 0.2s ease-out;
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"] {
  flex-direction: column;
}
.data-\\[state\\=checked\\]\\:border-\\[\\#2d6b0d\\][data-state="checked"] {
  --tw-border-opacity: 1;
  border-color: rgb(45 107 13 / var(--tw-border-opacity, 1));
}
.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"] {
  background-color: hsl(var(--accent));
}
.data-\\[state\\=active\\]\\:bg-\\[\\#dae8ce\\][data-state="active"] {
  --tw-bg-opacity: 1;
  background-color: rgb(218 232 206 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=active\\]\\:bg-\\[\\#f3f7ee\\][data-state="active"] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 247 238 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=active\\]\\:bg-white[data-state="active"] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=checked\\]\\:bg-\\[\\#2d6b0d\\][data-state="checked"] {
  --tw-bg-opacity: 1;
  background-color: rgb(45 107 13 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=checked\\]\\:bg-\\[\\#d9a63a\\][data-state="checked"] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 166 58 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"] {
  background-color: hsl(var(--primary));
}
.data-\\[state\\=checked\\]\\:bg-sky-600[data-state="checked"] {
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=on\\]\\:bg-accent[data-state="on"] {
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state="open"] {
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"] {
  background-color: hsl(var(--accent) / 0.5);
}
.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"] {
  background-color: hsl(var(--secondary));
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"] {
  background-color: hsl(var(--muted));
}
.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"] {
  background-color: hsl(var(--input));
}
.data-\\[state\\=active\\]\\:font-semibold[data-state="active"] {
  font-weight: 600;
}
.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder] {
  color: hsl(var(--muted-foreground));
}
.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"] {
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=active\\]\\:text-\\[\\#1e4a08\\][data-state="active"] {
  --tw-text-opacity: 1;
  color: rgb(30 74 8 / var(--tw-text-opacity, 1));
}
.data-\\[state\\=active\\]\\:text-\\[\\#2d6b0d\\][data-state="active"] {
  --tw-text-opacity: 1;
  color: rgb(45 107 13 / var(--tw-text-opacity, 1));
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"] {
  color: hsl(var(--primary-foreground));
}
.data-\\[state\\=inactive\\]\\:text-\\[\\#2d6b0d\\][data-state="inactive"] {
  --tw-text-opacity: 1;
  color: rgb(45 107 13 / var(--tw-text-opacity, 1));
}
.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"] {
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"] {
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"] {
  color: hsl(var(--muted-foreground));
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"] {
  opacity: 0.5;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled] {
  opacity: 0.5;
}
.data-\\[state\\=active\\]\\:shadow-none[data-state="active"] {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[state\\=active\\]\\:shadow-sm[data-state="active"] {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"] {
  transition-property: none;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
  transition-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
  transition-duration: 500ms;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"] {
  --tw-enter-opacity: 0;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"] {
  --tw-exit-opacity: 0.8;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"] {
  --tw-enter-opacity: 0;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"] {
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"] {
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"] {
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"] {
  --tw-enter-scale: .95;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"] {
  --tw-enter-translate-x: 13rem;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"] {
  --tw-enter-translate-x: -13rem;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"] {
  --tw-exit-translate-x: 13rem;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"] {
  --tw-exit-translate-x: -13rem;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"] {
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"] {
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"] {
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"] {
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"] {
  --tw-exit-translate-y: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"] {
  --tw-exit-translate-x: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"] {
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"] {
  --tw-exit-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"] {
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"] {
  --tw-enter-translate-y: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"] {
  --tw-enter-translate-x: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"] {
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"] {
  --tw-enter-translate-x: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"] {
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"] {
  --tw-enter-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"] {
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
  animation-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
  animation-duration: 500ms;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  left: 0px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  height: 0.25rem;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  width: 100%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"] {
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"] {
  background-color: hsl(var(--accent));
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media (prefers-reduced-motion: reduce) {

  .motion-reduce\\:transform-none {
    transform: none;
  }
}
.dark\\:border-destructive:is(.dark *) {
  border-color: hsl(var(--destructive));
}
@media (min-width: 640px) {

  .sm\\:relative {
    position: relative;
  }

  .sm\\:bottom-0 {
    bottom: 0px;
  }

  .sm\\:left-4 {
    left: 1rem;
  }

  .sm\\:right-0 {
    right: 0px;
  }

  .sm\\:right-4 {
    right: 1rem;
  }

  .sm\\:right-auto {
    right: auto;
  }

  .sm\\:top-auto {
    top: auto;
  }

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .sm\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:ml-auto {
    margin-left: auto;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:inline-flex {
    display: inline-flex;
  }

  .sm\\:aspect-auto {
    aspect-ratio: auto;
  }

  .sm\\:h-12 {
    height: 3rem;
  }

  .sm\\:h-full {
    height: 100%;
  }

  .sm\\:min-h-\\[260px\\] {
    min-height: 260px;
  }

  .sm\\:w-12 {
    width: 3rem;
  }

  .sm\\:w-48 {
    width: 12rem;
  }

  .sm\\:w-80 {
    width: 20rem;
  }

  .sm\\:w-\\[28rem\\] {
    width: 28rem;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:max-w-sm {
    max-width: 24rem;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .sm\\:grid-cols-\\[150px_1fr\\] {
    grid-template-columns: 150px 1fr;
  }

  .sm\\:grid-cols-\\[160px_1fr\\] {
    grid-template-columns: 160px 1fr;
  }

  .sm\\:grid-cols-\\[1fr_150px\\] {
    grid-template-columns: 1fr 150px;
  }

  .sm\\:grid-cols-\\[1fr_1fr_auto\\] {
    grid-template-columns: 1fr 1fr auto;
  }

  .sm\\:grid-cols-\\[1fr_200px\\] {
    grid-template-columns: 1fr 200px;
  }

  .sm\\:grid-cols-\\[1fr_260px\\] {
    grid-template-columns: 1fr 260px;
  }

  .sm\\:grid-cols-\\[1fr_auto\\] {
    grid-template-columns: 1fr auto;
  }

  .sm\\:grid-cols-\\[200px_1fr\\] {
    grid-template-columns: 200px 1fr;
  }

  .sm\\:grid-cols-\\[220px_1fr_auto\\] {
    grid-template-columns: 220px 1fr auto;
  }

  .sm\\:grid-cols-\\[auto_1fr_auto\\] {
    grid-template-columns: auto 1fr auto;
  }

  .sm\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:justify-center {
    justify-content: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-2 {
    gap: 0.5rem;
  }

  .sm\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-2xl {
    border-radius: 1rem;
  }

  .sm\\:rounded-lg {
    border-radius: var(--radius);
  }

  .sm\\:rounded-b-2xl {
    border-bottom-right-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }

  .sm\\:rounded-t-2xl {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }

  .sm\\:p-7 {
    padding: 1.75rem;
  }

  .sm\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:pr-0 {
    padding-right: 0px;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-right {
    text-align: right;
  }

  .sm\\:text-2xl {
    font-size: calc(1.5rem * var(--hs, 1));
    line-height: 1.3333;
  }

  .sm\\:text-3xl {
    font-size: calc(1.875rem * var(--hs, 1));
    line-height: 1.2;
  }

  .sm\\:text-4xl {
    font-size: calc(2.25rem * var(--hs, 1));
    line-height: 1.1111;
  }

  .sm\\:text-5xl {
    font-size: calc(3rem * var(--hs, 1));
    line-height: 1;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"] {
    --tw-enter-translate-y: 100%;
  }
}
@media (min-width: 768px) {

  .md\\:static {
    position: static;
  }

  .md\\:absolute {
    position: absolute;
  }

  .md\\:sticky {
    position: sticky;
  }

  .md\\:bottom-4 {
    bottom: 1rem;
  }

  .md\\:left-4 {
    left: 1rem;
  }

  .md\\:left-auto {
    left: auto;
  }

  .md\\:right-6 {
    right: 1.5rem;
  }

  .md\\:top-28 {
    top: 7rem;
  }

  .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .md\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .md\\:row-span-2 {
    grid-row: span 2 / span 2;
  }

  .md\\:line-clamp-none {
    overflow: visible;
    display: block;
    -webkit-box-orient: horizontal;
    -webkit-line-clamp: none;
  }

  .md\\:block {
    display: block;
  }

  .md\\:inline {
    display: inline;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:grid {
    display: grid;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:aspect-\\[16\\/10\\] {
    aspect-ratio: 16/10;
  }

  .md\\:aspect-auto {
    aspect-ratio: auto;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\] {
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:max-w-\\[420px\\] {
    max-width: 420px;
  }

  .md\\:max-w-md {
    max-width: 28rem;
  }

  .md\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[1\\.2fr_1fr\\] {
    grid-template-columns: 1.2fr 1fr;
  }

  .md\\:grid-cols-\\[150px_1fr_1fr_auto\\] {
    grid-template-columns: 150px 1fr 1fr auto;
  }

  .md\\:grid-cols-\\[1fr_400px\\] {
    grid-template-columns: 1fr 400px;
  }

  .md\\:grid-cols-\\[280px_1fr\\] {
    grid-template-columns: 280px 1fr;
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1\\.4fr\\)\\] {
    grid-template-columns: minmax(0,1fr) minmax(0,1.4fr);
  }

  .md\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-wrap {
    flex-wrap: wrap;
  }

  .md\\:gap-5 {
    gap: 1.25rem;
  }

  .md\\:whitespace-nowrap {
    white-space: nowrap;
  }

  .md\\:bg-transparent {
    background-color: transparent;
  }

  .md\\:p-0 {
    padding: 0px;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .md\\:pb-0 {
    padding-bottom: 0px;
  }

  .md\\:pb-10 {
    padding-bottom: 2.5rem;
  }

  .md\\:pt-6 {
    padding-top: 1.5rem;
  }

  .md\\:text-2xl {
    font-size: calc(1.5rem * var(--hs, 1));
    line-height: 1.3333;
  }

  .md\\:text-3xl {
    font-size: calc(1.875rem * var(--hs, 1));
    line-height: 1.2;
  }

  .md\\:text-4xl {
    font-size: calc(2.25rem * var(--hs, 1));
    line-height: 1.1111;
  }

  .md\\:text-5xl {
    font-size: calc(3rem * var(--hs, 1));
    line-height: 1;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .md\\:text-\\[inherit\\] {
    color: inherit;
  }

  .md\\:shadow-none {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
@media (min-width: 1024px) {

  .lg\\:sticky {
    position: sticky;
  }

  .lg\\:top-24 {
    top: 6rem;
  }

  .lg\\:top-28 {
    top: 7rem;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:row-span-2 {
    grid-row: span 2 / span 2;
  }

  .lg\\:-mx-10 {
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:inline {
    display: inline;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:grid {
    display: grid;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:w-\\[32rem\\] {
    width: 32rem;
  }

  .lg\\:w-\\[370px\\] {
    width: 370px;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[1\\.45fr_1fr\\] {
    grid-template-columns: 1.45fr 1fr;
  }

  .lg\\:grid-cols-\\[1fr_1\\.4fr\\] {
    grid-template-columns: 1fr 1.4fr;
  }

  .lg\\:grid-cols-\\[1fr_280px\\] {
    grid-template-columns: 1fr 280px;
  }

  .lg\\:grid-cols-\\[1fr_320px\\] {
    grid-template-columns: 1fr 320px;
  }

  .lg\\:grid-cols-\\[1fr_360px\\] {
    grid-template-columns: 1fr 360px;
  }

  .lg\\:grid-cols-\\[1fr_380px\\] {
    grid-template-columns: 1fr 380px;
  }

  .lg\\:grid-cols-\\[1fr_420px\\] {
    grid-template-columns: 1fr 420px;
  }

  .lg\\:grid-cols-\\[1fr_auto\\] {
    grid-template-columns: 1fr auto;
  }

  .lg\\:grid-cols-\\[240px_1fr\\] {
    grid-template-columns: 240px 1fr;
  }

  .lg\\:grid-cols-\\[300px_1fr\\] {
    grid-template-columns: 300px 1fr;
  }

  .lg\\:grid-cols-\\[320px_1fr\\] {
    grid-template-columns: 320px 1fr;
  }

  .lg\\:grid-cols-\\[320px_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: 320px minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[auto_1fr\\] {
    grid-template-columns: auto 1fr;
  }

  .lg\\:grid-cols-\\[minmax\\(320px\\2c 2fr\\)_3fr\\] {
    grid-template-columns: minmax(320px,2fr) 3fr;
  }

  .lg\\:grid-rows-\\[auto_1fr\\] {
    grid-template-rows: auto 1fr;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-end {
    align-items: flex-end;
  }

  .lg\\:items-stretch {
    align-items: stretch;
  }

  .lg\\:gap-14 {
    gap: 3.5rem;
  }

  .lg\\:gap-8 {
    gap: 2rem;
  }

  .lg\\:rounded-tr-2xl {
    border-top-right-radius: 1rem;
  }

  .lg\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:text-3xl {
    font-size: calc(1.875rem * var(--hs, 1));
    line-height: 1.2;
  }

  .lg\\:text-4xl {
    font-size: calc(2.25rem * var(--hs, 1));
    line-height: 1.1111;
  }

  .lg\\:text-5xl {
    font-size: calc(3rem * var(--hs, 1));
    line-height: 1;
  }

  .lg\\:text-6xl {
    font-size: calc(3.75rem * var(--hs, 1));
    line-height: 1;
  }

  .lg\\:text-hero {
    font-size: calc(3.4rem * var(--hs, 1));
    line-height: 1.1;
  }
}
@media (min-width: 1280px) {

  .xl\\:inline {
    display: inline;
  }

  .xl\\:flex {
    display: flex;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[200px_200px_minmax\\(0\\2c 1fr\\)_220px\\] {
    grid-template-columns: 200px 200px minmax(0,1fr) 220px;
  }
}
@media (min-width: 1536px) {

  .\\32xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .\\32xl\\:gap-10 {
    gap: 2.5rem;
  }
}
@media print {

  .print\\:hidden {
    display: none;
  }
}
.\\[\\&\\+div\\]\\:text-xs+div {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
  display: none;
}
.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end) {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start) {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]) {
  border-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]) {
  background-color: hsl(var(--accent));
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside) {
  background-color: hsl(var(--accent) / 0.5);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end) {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]) {
  padding-right: 0px;
}
.\\[\\&\\:not\\(\\[aria-selected\\]\\)\\]\\:bg-amber-50:not([aria-selected]) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.\\[\\&\\:not\\(\\[aria-selected\\]\\)\\]\\:bg-green-100:not([aria-selected]) {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.\\[\\&\\:not\\(\\[aria-selected\\]\\)\\]\\:bg-green-50:not([aria-selected]) {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.\\[\\&\\:not\\(\\[aria-selected\\]\\)\\]\\:bg-red-100:not([aria-selected]) {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.\\[\\&\\:not\\(\\[aria-selected\\]\\)\\]\\:text-stone-400:not([aria-selected]) {
  --tw-text-opacity: 1;
  color: rgb(168 162 158 / var(--tw-text-opacity, 1));
}
.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox] {
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>button\\]\\:hidden>button {
  display: none;
}
.\\[\\&\\>button\\]\\:text-white>button {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.\\[\\&\\>span\\]\\:line-clamp-1>span {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div {
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>svg\\]\\:absolute>svg {
  position: absolute;
}
.\\[\\&\\>svg\\]\\:left-4>svg {
  left: 1rem;
}
.\\[\\&\\>svg\\]\\:top-4>svg {
  top: 1rem;
}
.\\[\\&\\>svg\\]\\:size-4>svg {
  width: 1rem;
  height: 1rem;
}
.\\[\\&\\>svg\\]\\:h-3\\.5>svg {
  height: 0.875rem;
}
.\\[\\&\\>svg\\]\\:w-3\\.5>svg {
  width: 0.875rem;
}
.\\[\\&\\>svg\\]\\:shrink-0>svg {
  flex-shrink: 0;
}
.\\[\\&\\>svg\\]\\:text-destructive>svg {
  color: hsl(var(--destructive));
}
.\\[\\&\\>svg\\]\\:text-foreground>svg {
  color: hsl(var(--foreground));
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~* {
  padding-left: 1.75rem;
}
.\\[\\&\\>td\\]\\:py-3>td {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&\\>td\\]\\:align-top>td {
  vertical-align: top;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr {
  border-bottom-width: 0px;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading] {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading] {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading] {
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading] {
  color: hsl(var(--muted-foreground));
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group] {
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg {
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg {
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input] {
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item] {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg {
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg {
  width: 1.25rem;
}
.\\[\\&_a\\]\\:pointer-events-auto a {
  pointer-events: auto;
}
.\\[\\&_a\\]\\:text-\\[\\#2d6b0d\\] a {
  --tw-text-opacity: 1;
  color: rgb(45 107 13 / var(--tw-text-opacity, 1));
}
.\\[\\&_a\\]\\:underline a {
  text-decoration-line: underline;
}
.\\[\\&_blockquote\\]\\:border-l-4 blockquote {
  border-left-width: 4px;
}
.\\[\\&_blockquote\\]\\:border-\\[\\#2d6b0d\\] blockquote {
  --tw-border-opacity: 1;
  border-color: rgb(45 107 13 / var(--tw-border-opacity, 1));
}
.\\[\\&_blockquote\\]\\:pl-3 blockquote {
  padding-left: 0.75rem;
}
.\\[\\&_blockquote\\]\\:text-stone-600 blockquote {
  --tw-text-opacity: 1;
  color: rgb(87 83 78 / var(--tw-text-opacity, 1));
}
.\\[\\&_h2\\]\\:my-3 h2 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.\\[\\&_h2\\]\\:text-xl h2 {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.\\[\\&_h2\\]\\:font-semibold h2 {
  font-weight: 600;
}
.\\[\\&_h2\\]\\:text-\\[\\#2d6b0d\\] h2 {
  --tw-text-opacity: 1;
  color: rgb(45 107 13 / var(--tw-text-opacity, 1));
}
.\\[\\&_h3\\]\\:my-2 h3 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.\\[\\&_h3\\]\\:text-base h3 {
  font-size: 1rem;
  line-height: 1.5rem;
}
.\\[\\&_h3\\]\\:font-semibold h3 {
  font-weight: 600;
}
.\\[\\&_hr\\]\\:my-3 hr {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.\\[\\&_img\\]\\:max-w-full img {
  max-width: 100%;
}
.\\[\\&_ol\\]\\:my-2 ol {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.\\[\\&_ol\\]\\:list-decimal ol {
  list-style-type: decimal;
}
.\\[\\&_ol\\]\\:pl-6 ol {
  padding-left: 1.5rem;
}
.\\[\\&_p\\]\\:my-2 p {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.\\[\\&_p\\]\\:\\!mb-2 p {
  margin-bottom: 0.5rem !important;
}
.\\[\\&_p\\]\\:\\!mt-0 p {
  margin-top: 0px !important;
}
.\\[\\&_p\\]\\:leading-relaxed p {
  line-height: 1.625;
}
.\\[\\&_svg\\]\\:pointer-events-none svg {
  pointer-events: none;
}
.\\[\\&_svg\\]\\:size-4 svg {
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg {
  flex-shrink: 0;
}
.\\[\\&_table\\]\\:my-2 table {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.\\[\\&_table\\]\\:border-collapse table {
  border-collapse: collapse;
}
.\\[\\&_td\\]\\:border td {
  border-width: 1px;
}
.\\[\\&_td\\]\\:border-stone-200 td {
  --tw-border-opacity: 1;
  border-color: rgb(231 229 228 / var(--tw-border-opacity, 1));
}
.\\[\\&_td\\]\\:px-2 td {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_td\\]\\:py-1 td {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.\\[\\&_th\\]\\:border th {
  border-width: 1px;
}
.\\[\\&_th\\]\\:border-stone-200 th {
  --tw-border-opacity: 1;
  border-color: rgb(231 229 228 / var(--tw-border-opacity, 1));
}
.\\[\\&_th\\]\\:px-2 th {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_th\\]\\:py-1 th {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child {
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr {
  border-bottom-width: 1px;
}
.\\[\\&_ul\\]\\:my-2 ul {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.\\[\\&_ul\\]\\:list-disc ul {
  list-style-type: disc;
}
.\\[\\&_ul\\]\\:pl-6 ul {
  padding-left: 1.5rem;
}
@media(hover:none) {

  .\\[\\@media\\(hover\\:none\\)\\]\\:opacity-100 {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,wBAAc;IAAd,sBAAc;IAAd,iBAAc;IAAd,2BAAc;IAAd,oBAAc;IAAd,8BAAc;IAAd,sBAAc;IAAd,gCAAc;IAAd,uBAAc;IAAd,mCAAc;IAAd,mBAAc;IAAd,4BAAc;IAAd,oBAAc;IAAd,8BAAc;IAAd,yBAAc;IAAd,kCAAc;IAAd,oBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,iBAAc;EAAA;EAAd;IAAA,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,6BAAc;IAAd,qBAAc;IAAd,gCAAc;IAAd,sBAAc;IAAd,+BAAc;IAAd,uBAAc;IAAd,kCAAc;IAAd,mBAAc;IAAd,8BAAc;IAAd,oBAAc;IAAd,8BAAc;IAAd,wBAAc;IAAd,oCAAc;IAAd,oBAAc;IAAd,mBAAc;IAAd,mBAAc;EAAA;EAAd;EAAA;AAAc;EAAd;EAAA,wCAAc;EAAd;AAAc;EAAd,8BAAA,4BAAc,EAAA;AAEd;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,uEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,6HAA6H;AAC7H,aAAa,iCAAiC,EAAE,mBAAmB,EAAE,oBAAoB,EAAE,wBAAwB,EAAE,wBAAwB,EAAE,qBAAqB,EAAE;AACtK,aAAa,6BAA6B,EAAE,mBAAmB,EAAE,oBAAoB,EAAE,uBAAuB,EAAE,wBAAwB,EAAE,qBAAqB,EAAE;;;AAGjK,0FAA0F;AAC1F;EACE,oBAAoB,EAAE,wBAAwB,EAAE,uBAAuB,EAAE,wBAAwB;EACjG,oBAAoB,EAAE,kBAAkB,EAAE,mBAAmB;EAC7D,qBAAqB,EAAE,qBAAqB,EAAE,qBAAqB,EAAE,qBAAqB,EAAE,iBAAiB;EAC7G,6BAA6B,EAAE,yBAAyB,EAAE,0BAA0B,EAAE,oBAAoB;EAC1G,wBAAwB,EAAE,4BAA4B,EAAE,yBAAyB;EACjF,wBAAwB,EAAE,2BAA2B,EAAE,0BAA0B,EAAE,iBAAiB;EACpG,WAAW,EAAE,QAAQ,EAAE,QAAQ,EAAE,QAAQ,EAAE,mBAAmB;EAC9D,wBAAwB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,gBAAgB;EACpF,qBAAqB,EAAE,uBAAuB;AAChD;;AAEA,gFAAgF;AAChF,gBAAgB,+BAA+B,EAAE,kCAAkC,EAAE;AACrF,qBAAqB,cAAc,EAAE,4CAA4C,EAAE;AACnF,wBAAwB,+BAA+B,EAAE,iBAAiB,EAAE,mCAAmC,EAAE;AACjH,qBAAqB,mCAAmC,EAAE;AAC1D,4BAA4B,gBAAgB,2CAA2C,EAAE,8CAA8C,EAAE,EAAE;AAC3I,iKAAiK;AACjK,mDAAmD,wBAAwB,EAAE,kCAAkC,EAAE;AACjH,uIAAuI;AACvI;EACE,mDAAmD,mCAAmC,EAAE;EACxF,gDAAgD,mCAAmC,EAAE;EACrF,2IAA2I,mCAAmC,EAAE;EAChL,oCAAoC,mCAAmC,EAAE;AAC3E;;AAEA,OAAO,2BAA2B,EAAE;AACpC,gGAAgG;AAChG,KAAK,sCAAsC,EAAE;AAC7C,KAAK,sCAAsC,EAAE;AAC7C,KAAK,sCAAsC,EAAE;;AAE7C;EACE,SAAS;EACT,8FAA8F;EAC9F,mCAAmC;EACnC,kCAAkC;EAClC,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,4GAA4G;EAC5G,uCAAuC;EACvC,uBAAuB;AACzB;;AAqDA;EACE,yHAAyH;AAC3H;;AAEA;yFACyF;AACzF,YAAY,kBAAkB,EAAE,MAAM,EAAE,OAAO,EAAE,WAAW,EAAE,sCAAsC,EAAE,iBAAiB,EAAE;AACzH,4BAA4B,YAAY,wBAAwB,EAAE,EAAE;;AAEpE;EACE,sDAAsD;EACtD,yCAAyC;EACzC,iDAAiD;EACjD,+CAA+C;AACjD;;AAEA;EACE,+EAA+E;AACjF;AACA,oBAAoB,2BAA2B,EAAE,qDAAqD,EAAE;;AAExG;EACE,yDAAyD;AAC3D;AACA,4BAA4B,sBAAsB,EAAE;;AAEpD;EACE,WAAW;EACX,kBAAkB,EAAE,QAAQ;EAC5B,gVAAgV;EAChV,oBAAoB;EACpB,YAAY;EACZ,wBAAwB;AAC1B;;AAMA,2DAA2D;AAC3D,kBAAkB,qBAAqB,EAAE,oDAAoD,EAAE;AAC/F,qCAAqC,UAAU,EAAE;AACjD,2CAA2C,mCAAmC,EAAE,qBAAqB,EAAE;;;AAGvG,4FAA4F;AAC5F,6CAA6C,aAAa,EAAE;AAC5D,2HAA2H;AAC3H,kBAAkB,6BAA6B,EAAE,yBAAyB,EAAE,iBAAiB,EAAE,2BAA2B,EAAE,uBAAuB,EAAE,+BAA+B,EAAE;AACtL,oCAAoC,2BAA2B,EAAE;AACjE,oHAAoH;AACpH,4BAA4B,6EAA6E,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,EAAE;AACnK,yHAAyH;AACzH,gBAAgB,mEAAmE,EAAE;;AAErF,gFAAgF;AAChF,qBAAqB,8CAA8C,EAAE;AACrE,oBAAoB,2DAA2D,EAAE;AACjF,kBAAkB,4DAA4D,EAAE;AAxKhF;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,mBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,0BAyKA;EAzKA;AAyKA;AAzKA;EAAA,0BAyKA;EAzKA,QAyKA;EAzKA;AAyKA;AAzKA;EAAA,0BAyKA;EAzKA;AAyKA;AAzKA;EAAA,0BAyKA;EAzKA;AAyKA;AAzKA;EAAA,0BAyKA;EAzKA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,iDAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kDAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,2BAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,iBAyKA;EAzKA,iBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,+EAyKA;EAzKA,mGAyKA;EAzKA;AAyKA;AAzKA;EAAA,6EAyKA;EAzKA,iGAyKA;EAzKA;AAyKA;AAzKA;EAAA,0CAyKA;EAzKA,uDAyKA;EAzKA;AAyKA;AAzKA;EAAA,gFAyKA;EAzKA,oGAyKA;EAzKA;AAyKA;AAzKA;EAAA,2GAyKA;EAzKA,yGAyKA;EAzKA;AAyKA;AAzKA;EAAA,2GAyKA;EAzKA,yGAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,gCAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,8BAyKA;EAzKA;AAyKA;AAzKA;EAAA,2GAyKA;EAzKA,yGAyKA;EAzKA;AAyKA;AAzKA;EAAA,2GAyKA;EAzKA,yGAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,8BAyKA;EAzKA;AAyKA;AAzKA;EAAA,2GAyKA;EAzKA,yGAyKA;EAzKA;AAyKA;AAzKA;EAAA,2GAyKA;EAzKA,yGAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,0BAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,+EAyKA;EAzKA,mGAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,yBAyKA;EAzKA;AAyKA;AAzKA;EAAA,0BAyKA;EAzKA;AAyKA;AAzKA;EAAA,yBAyKA;EAzKA;AAyKA;AAzKA;EAAA,0BAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,qBAyKA;EAzKA;AAyKA;AAzKA;EAAA,qBAyKA;EAzKA;AAyKA;AAzKA;EAAA,gDAyKA;EAzKA;AAyKA;AAzKA;EAAA,iDAyKA;EAzKA;AAyKA;AAzKA;;EAAA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;AAAA;AAzKA;EAAA;AAyKA;AAzKA;;EAAA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;AAAA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA,8BAyKA;EAzKA;AAyKA;AAzKA;EAAA,0CAyKA;EAzKA,uDAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,qBAyKA;EAzKA,yBAyKA;EAzKA,2BAyKA;EAzKA,yBAyKA;EAzKA,0BAyKA;EAzKA,+BAyKA;EAzKA;AAyKA;AAzKA;EAAA,qBAyKA;EAzKA,yBAyKA;EAzKA,2BAyKA;EAzKA,yBAyKA;EAzKA,0BAyKA;EAzKA,+BAyKA;EAzKA;AAyKA;AAzKA;EAAA,qBAyKA;EAzKA,yBAyKA;EAzKA,2BAyKA;EAzKA,yBAyKA;EAzKA,0BAyKA;EAzKA,+BAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA,yBAyKA;EAzKA,0BAyKA;EAzKA,wBAyKA;EAzKA,yBAyKA;EAzKA,8BAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA,yBAyKA;EAzKA,0BAyKA;EAzKA,wBAyKA;EAzKA,yBAyKA;EAzKA,8BAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA,yBAyKA;EAzKA,0BAyKA;EAzKA,wBAyKA;EAzKA,yBAyKA;EAzKA,8BAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA,yBAyKA;EAzKA,0BAyKA;EAzKA,wBAyKA;EAzKA,yBAyKA;EAzKA,8BAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,0BAyKA;EAzKA;AAyKA;AAzKA;EAAA,0BAyKA;EAzKA;AAyKA;AAzKA;EAAA,0BAyKA;EAzKA;AAyKA;AAzKA;EAAA,0BAyKA;EAzKA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,0BAyKA;EAzKA,qBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,mBAyKA;EAzKA;AAyKA;AAzKA;;EAAA;IAAA;EAyKA;AAAA;AAzKA;EAAA;AAyKA;AAzKA;;EAAA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,gBAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,uBAyKA;IAzKA,sDAyKA;IAzKA;EAyKA;;EAzKA;IAAA,uBAyKA;IAzKA,oDAyKA;IAzKA;EAyKA;;EAzKA;IAAA,uBAyKA;IAzKA,2DAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,gCAyKA;IAzKA;EAyKA;;EAzKA;IAAA,4BAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,kBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,oBAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,sCAyKA;IAzKA;EAyKA;;EAzKA;IAAA,wCAyKA;IAzKA;EAyKA;;EAzKA;IAAA,uCAyKA;IAzKA;EAyKA;;EAzKA;IAAA,oCAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;AAAA;AAzKA;;EAAA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,iBAyKA;IAzKA,cAyKA;IAzKA,8BAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,iBAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,sCAyKA;IAzKA;EAyKA;;EAzKA;IAAA,wCAyKA;IAzKA;EAyKA;;EAzKA;IAAA,uCAyKA;IAzKA;EAyKA;;EAzKA;IAAA,oCAyKA;IAzKA;EAyKA;;EAzKA;IAAA,eAyKA;IAzKA;EAyKA;;EAzKA;IAAA,mBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,mBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,kBAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,sBAyKA;IAzKA,8BAyKA;IAzKA;EAyKA;AAAA;AAzKA;;EAAA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,oBAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,oBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,kBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,wCAyKA;IAzKA;EAyKA;;EAzKA;IAAA,uCAyKA;IAzKA;EAyKA;;EAzKA;IAAA,oCAyKA;IAzKA;EAyKA;;EAzKA;IAAA,uCAyKA;IAzKA;EAyKA;;EAzKA;IAAA,sCAyKA;IAzKA;EAyKA;AAAA;AAzKA;;EAAA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;AAAA;AAzKA;;EAAA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;AAAA;AAzKA;;EAAA;IAAA;EAyKA;AAAA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kDAyKA;EAzKA;AAyKA;AAzKA;EAAA,iDAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,iDAyKA;EAzKA;AAyKA;AAzKA;EAAA,kDAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kDAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,qBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,gBAyKA;EAzKA,oBAyKA;EAzKA,4BAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,WAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,mBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,qBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,mBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,eAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,mBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,WAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;;EAAA;IAAA;EAyKA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Ersatzschriften mit angepassten Metriken: Text steht vor dem Webfont fast deckungsgleich (kein Sprung beim Font-Wechsel) */\n@font-face { font-family: \"Open Sans Fallback\"; src: local(\"Arial\"); size-adjust: 105.64%; ascent-override: 101.18%; descent-override: 27.73%; line-gap-override: 0%; }\n@font-face { font-family: \"Inter Fallback\"; src: local(\"Arial\"); size-adjust: 107.64%; ascent-override: 90.49%; descent-override: 22.56%; line-gap-override: 0%; }\n\n\n/* Design-Standardwerte (Admin → Design überschreibt sie per Inline-Variablen am <html>) */\n:root {\n  --c-brand: 45 107 13; --c-brand-hover: 30 74 8; --c-brand-dark: 36 86 9; --c-brand-deep: 47 90 18;\n  --c-gold: 217 166 58; --c-sun: 240 180 0; --c-signal: 208 0 0;\n  --c-line: 207 224 191; --c-soft: 218 232 206; --c-tint: 243 247 238; --c-page: 247 250 243; --c-ink: 51 51 51;\n  --c-footer-light: 183 204 143; --c-footer-mid: 87 130 38; --c-footer-dark: 51 107 15; --c-trash: 185 28 28;\n  --c-badge-offer: 208 0 0; --c-badge-instant: 45 107 13; --c-badge-new: 217 166 58;\n  --font-body: \"Open Sans\"; --font-heading: \"Open Sans\"; --font-heading-weight: 600; --font-base: 16px;\n  --hs-all: 1; --h1s: 1; --h2s: 1; --h3s: 1; --hs: var(--hs-all);\n  --header-bg: 250 248 245; --header-bg-a: 0.82; --header-blur: 14px; --header-h: 80px;\n  --home-sec-py: 2.5rem; --home-sec-head: 1.5rem;\n}\n\n/* Abschnitte der Startseite (Admin → Design → Startseite → Abschnittsabstand) */\n.home-section { padding-top: var(--home-sec-py); padding-bottom: var(--home-sec-py); }\n.home-section-half { padding-top: 0; padding-bottom: calc(var(--home-sec-py) / 2); }\n.home-section-heading { padding-top: var(--home-sec-py); padding-bottom: 0; margin-bottom: var(--home-sec-head); }\n.home-section-head { margin-bottom: var(--home-sec-head); }\n@media (max-width: 767px) { .home-section { padding-top: calc(var(--home-sec-py) * 0.8); padding-bottom: calc(var(--home-sec-py) * 0.8); } }\n/* Abschnitte außerhalb des Sichtbereichs erst rendern, wenn sie näher kommen: spart Layout/Paint bei jedem Datenupdate (Inhalt bleibt im DOM, SEO unverändert) */\n.home-section, footer[data-testid=\"site-footer\"] { content-visibility: auto; contain-intrinsic-size: auto 800px; }\n/* Platzhalterhöhe muss ≥ echter Höhe sein, sonst ragen ungerenderte Karten rechnerisch in den Folgeabschnitt (axe „target obscured“) */\n@media (max-width: 767px) {\n  .home-section, footer[data-testid=\"site-footer\"] { contain-intrinsic-size: auto 1400px; }\n  .home-section[data-testid=\"featured-section\"] { contain-intrinsic-size: auto 2600px; }\n  .home-section[data-testid=\"new-properties-section\"], .home-section[data-testid=\"home-tips\"], .home-section[data-testid=\"home-complexes\"] { contain-intrinsic-size: auto 2000px; }\n  footer[data-testid=\"site-footer\"] { contain-intrinsic-size: auto 2400px; }\n}\n\nhtml { font-size: var(--font-base); }\n/* Überschriften-Größe je Ebene (Admin → Design → Schrift): Tailwind text-*xl rechnet mit --hs */\nh1 { --hs: calc(var(--hs-all) * var(--h1s)); }\nh2 { --hs: calc(var(--hs-all) * var(--h2s)); }\nh3 { --hs: calc(var(--hs-all) * var(--h3s)); }\n\nbody {\n  margin: 0;\n  font-family: var(--font-body), \"Open Sans\", \"Open Sans Fallback\", Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: rgb(var(--c-page));\n  color: rgb(var(--c-ink));\n}\n\n.font-serif {\n  font-family: var(--font-heading), \"Open Sans\", \"Open Sans Fallback\", Helvetica, Arial, sans-serif !important;\n  font-weight: var(--font-heading-weight);\n  letter-spacing: -0.01em;\n}\n\n@layer base {\n  :root {\n    --background: 90 30% 97%;\n    --foreground: 0 0% 20%;\n    --card: 0 0% 100%;\n    --card-foreground: 0 0% 20%;\n    --popover: 0 0% 100%;\n    --popover-foreground: 0 0% 20%;\n    --primary: 100 78% 24%;\n    --primary-foreground: 90 30% 97%;\n    --secondary: 92 37% 86%;\n    --secondary-foreground: 100 78% 20%;\n    --muted: 90 25% 94%;\n    --muted-foreground: 0 0% 40%;\n    --accent: 98 47% 40%;\n    --accent-foreground: 0 0% 100%;\n    --destructive: 0 100% 41%;\n    --destructive-foreground: 0 0% 98%;\n    --border: 92 35% 82%;\n    --input: 92 35% 82%;\n    --ring: 100 78% 24%;\n    --radius: 0.75rem;\n  }\n  .dark {\n    --background: 20 14% 8%;\n    --foreground: 40 33% 95%;\n    --card: 20 14% 12%;\n    --card-foreground: 40 33% 95%;\n    --popover: 20 14% 12%;\n    --popover-foreground: 40 33% 95%;\n    --primary: 205 60% 55%;\n    --primary-foreground: 20 14% 8%;\n    --secondary: 20 10% 18%;\n    --secondary-foreground: 40 33% 95%;\n    --muted: 20 10% 18%;\n    --muted-foreground: 40 10% 65%;\n    --accent: 18 65% 60%;\n    --accent-foreground: 20 14% 8%;\n    --destructive: 0 63% 45%;\n    --destructive-foreground: 40 33% 95%;\n    --border: 20 10% 22%;\n    --input: 20 10% 22%;\n    --ring: 205 60% 55%;\n  }\n}\n\n@layer base {\n  * { @apply border-border; }\n  body { @apply bg-background text-foreground; }\n}\n\n.hero-gradient-overlay {\n  background: linear-gradient(135deg, rgba(14, 75, 117, 0.55) 0%, rgba(28, 25, 23, 0.35) 60%, rgba(217, 107, 67, 0.2) 100%);\n}\n\n/* Titelbild: feste, vom Inhalt unabhängige Höhe (Handy 115vh, Desktop = Hero-Mindesthöhe), damit die statische Hülle aus index.html\n   vor React pixelgleich dasselbe zeigt; der Abschnitt schneidet per overflow:hidden ab */\n.hero-img { position: absolute; top: 0; left: 0; width: 100%; height: max(100%, var(--hero-h, 92vh)); object-fit: cover; }\n@media (max-width: 767px) { .hero-img { height: max(100%, 115vh); } }\n\n.glass-header {\n  background: rgb(var(--header-bg) / var(--header-bg-a));\n  backdrop-filter: blur(var(--header-blur));\n  -webkit-backdrop-filter: blur(var(--header-blur));\n  border-bottom: 1px solid rgba(28, 25, 23, 0.06);\n}\n\n.card-hover {\n  transition: transform 0.4s cubic-bezier(0.2, 0.9, 0.3, 1), box-shadow 0.4s ease;\n}\n.card-hover:hover { transform: translateY(-4px); box-shadow: 0 24px 48px -20px rgba(14, 75, 117, 0.25); }\n\n.img-hover-zoom img {\n  transition: transform 0.7s cubic-bezier(0.2, 0.9, 0.3, 1);\n}\n.img-hover-zoom:hover img { transform: scale(1.06); }\n\n.grain::before {\n  content: \"\";\n  position: absolute; inset: 0;\n  background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2'/><feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\");\n  pointer-events: none;\n  opacity: 0.6;\n  mix-blend-mode: multiply;\n}\n\n@layer base {\n  [data-debug-wrapper=\"true\"] { display: contents !important; }\n}\n\n/* Schmale Scrollleiste für die Buchungsbox (Objektseite) */\n.scrollbar-thin { scrollbar-width: thin; scrollbar-color: rgba(45, 107, 13, 0.35) transparent; }\n.scrollbar-thin::-webkit-scrollbar { width: 6px; }\n.scrollbar-thin::-webkit-scrollbar-thumb { background: rgba(45, 107, 13, 0.35); border-radius: 9999px; }\n\n\n/* Objektkarte: Hover-Kärtchen ohne Spitze, wenn es seitlich/unten versetzt angezeigt wird */\n.ph-pop-notip .leaflet-popup-tip-container { display: none; }\n/* Verschiebbarer Marker im Objektformular (LocationPicker): Touch/Pointer-Drag ohne Seitenscroll, deutlicher Greifcursor */\n.ph-drag-marker { touch-action: none !important; -webkit-user-select: none; user-select: none; -webkit-touch-callout: none; cursor: grab !important; pointer-events: auto !important; }\n.leaflet-dragging .ph-drag-marker { cursor: grabbing !important; }\n/* Mobil: Chat-Knopf über die feste „Jetzt buchen“-Leiste der Objektseite heben, damit er den Knopf nicht verdeckt */\n@media (max-width: 767px) { body:has([data-testid=\"mobile-booking-bar\"]) [data-testid=\"chat-open-btn\"] { bottom: 5.5rem; width: 3rem; height: 3rem; right: 1rem; } }\n/* Bild-Badge „Neu“: minimale Abdunklung (8 %), damit weiße 10-px-Schrift auch bei hellen Wunschfarben ≥ 4,5:1 erreicht */\n.bg-badge-new { background-image: linear-gradient(rgba(0,0,0,.08), rgba(0,0,0,.08)); }\n\n/* Vermieter-Homepage: neutrale Schriftvarianten (keine zusätzlichen Webfonts) */\n.site-font-classic { font-family: Georgia, \"Times New Roman\", serif; }\n.site-font-modern { font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif; }\n.site-font-warm { font-family: \"Trebuchet MS\", Verdana, \"Segoe UI\", sans-serif; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
